import {Tr} from "@/i18n/i18n";
import store from "@/store";
import {
  AnimType,
  ArrowMode,
  ArtifactPlace,
  ConsumablePlace,
  CustomPlace,
  Education,
  GainablePlace,
  HeroComment,
  Place,
  PlaceDisplayType,
  PlaceType,
  PlaceVisitor,
  PointerPlace,
  PortalPlace,
  PositionType,
  ResourcePlace,
  ResourceType,
  RunePlace,
  ScriptPlace,
  SkillPlace,
  Talk,
  TalkerPlace, TeleportDto,
  Tile,
  TurnPlace,
} from "@/store/place/types";
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {PlaceService} from "@/services/place-service";
import {Keys} from "@/constants/key";
import {Settings} from "@/constants/settings";
import ResourceUtils from "@/utils/resource-utils";
import {CustomPlaceService} from "@/services/custom-place-service";
import {RoadLessonService} from "@/services/road-lesson-service";
import {MenuService} from "@/services/menu-service";
import {ResourceService} from "@/services/resource-service";
import {SceneService} from "@/services/scene-service";
import {SceneName} from "@/model/scene-name";
import {ExperienceService} from "@/services/experience-service";
import {
  AppRateType,
  ControlType,
  DefaultWorld,
  GiftNews,
  HeroLook,
  InterfaceMode,
  Lang,
  Notification,
  Player,
  PlayerShortInfo,
  Quality,
  RoadNews,
  UserSource,
  WorldType
} from "@/store/player/types";
import ListenerManager from "@/managers/listener-manager";
import {ArtifactService} from "@/services/artifact-service";
import {ConsumableService} from "@/services/consumable-service";
import {RuneService} from "@/services/rune-service";
import {RandomUtils} from "@/utils/random-utils";
import {ShopService, TabName} from "@/services/shop-service";
import {ArtifactNotificationService} from "@/services/artifact-notification-service";
import SceneUtils from "@/utils/scene-utils";
import {RewardService} from "@/services/reward-service";
import {TileRoad} from "@/model/road";
import {TaskService} from "@/services/task-service";
import {ImageTextPanel} from "@/scenes.ui/image-text-panel";
import {Stop} from "@/model/stop";
import AnimationUtils from "@/utils/animation-utils";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {HealthService} from "@/services/health-service";
import {PlayerSpeedService} from "@/services/player-speed-service";
import {ProfileService} from "@/services/profile-service";
import {PlaceCreaturePanel} from "@/scenes.ui/place-creature-panel";
import {PaymentNotificationService} from "@/services/payment-notification-service";
import {MusicUtils} from "@/utils/music-utils";
import {GameSoundService} from "@/services/game-sound-service";
import {CampaignService} from "@/services/campaign-service";
import {PlayerCreatureService} from "@/services/player-creature-service";
import {PlayerActionButton} from "@/scenes.ui/player-action-button";
import {ArenaDescPanel} from "@/scenes.ui/arena-desc-panel";
import {GenderChangeService} from "@/services/gender-change-service";
import {RenamePlayerService} from "@/services/rename-player-service";
import {MagicPlaceService} from "@/services/magic-place-service";
import CU from "../utils/c-u";
import OnceCaller from "@/utils/once-caller";
import {ClanService} from "@/services/clan-service";
import {ExchangePanel} from "@/scenes.ui/exchange-panel";
import {ExchangeAmount, ExchangeTerms} from "@/store/exchange/types";
import {IntroPanel} from "@/scenes.ui/intro-panel";
import {ListService} from "@/services/list-service";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {ClanControlAction, ClanmanInfo, ClanShortInfo} from "@/store/clan/types";
import {MemberActionPanel} from "@/scenes.ui.clan/member-action-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import ClanUtils from "@/utils/clan-utils";
import SoundUtils from "@/utils/sound-utils";
import AtlasUtils from "@/utils/atlas-utils";
import {SoloIntroPanel} from "@/scenes.ui/solo-intro-panel";
import BattleStore from "@/store/battle";
import ClanStore from "@/store/clan";
import ExchangeStore from "@/store/exchange";
import PlayerStore from "@/store/player";
import PlaceStore from "@/store/place";
import {HeroShopService} from "@/services/hero-shop-service";
import {NewsPanel} from "@/scenes.ui/news-panel";
import {Version} from "@/constants/version";
import {ForumService} from "@/services/forum-service";
import {GiftService} from "@/services/gift-service";
import {HeroTownShopService} from "@/services/hero-town-shop-service";
import {PointsReminderPanel} from "@/scenes.ui/points-reminder-panel";
import {HeroShopType} from "@/store/shop/types";
import {TitanTownShopService} from "@/services/titan-town-shop-service";
import {LawService} from "@/services/law-service";
import {LawServiceBeeline} from "@/services/law-service-beeline";
import {CustomPlaceContainer} from "@/scenes.ui/custom-place-container";
import {PaymentChangeService} from "@/services/payment-change-service";
import {IapService} from "@/services/iap-service";
import {TenjinService} from "@/services/tenjin-service";
import {AppmetricaService} from "@/services/appmetrica-service";
import {CapacitorService} from "@/services/capacitor-service";
import {KeysNoLoad} from "@/constants/keys-no-load";
import SpriteUtils from "@/utils/sprite-utils";
import {GameState} from "@/constants/game-state";
import {LoadUtils, PriorityType} from "@/utils/load-utils";
import {RateAppService} from "@/services/rate-app-service";
import {PromoSoloPanel} from "@/scenes.ui/promo-solo-panel";
import http from "@/axios";
import {CampaignWheelPanel2} from "@/scenes.ui/campaign-wheel-panel2";
import ArtifactUtils from "@/utils/artifact-utils";
import {MailOrPhoneService} from "@/services/mail-or-phone-service";
import {PasswordService} from "@/services/password-service";
import PortalStore from "@/store/portal";
import {PortalDto} from "@/store/portal/types";
import {PortalPanel} from "@/scenes.ui/portal-panel";
import {AngelTownShopService} from "@/services/angel-town-shop-service";
import SkillUtils from "@/utils/skill-utils";
import {YotunTownShopService} from "@/services/yotun-town-shop-service";
import {SurTownShopService} from "@/services/sur-town-shop-service";
import TaskStore from "@/store/task";
import {DarkenPipeline} from "@/shaders/darkenPipeline";
import EducationPanel from "@/scenes.ui/education-panel";
import {MenuCreaturesNavPanel} from "@/scenes.ui/menu-creatures-nav-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {Point} from "@/model/point";
import ParticleUtils from "@/utils/particle-utils";
import {ArrowAnimData, EducationService, EducationServiceCallbacks, HandAnimData} from "@/services/education-service";
import {PhrasePanel} from "@/scenes.ui/phrase-panel";
import EduWithButton from "@/scenes.ui/edu-with-button";
import {Listener} from "@/store/listener";
import {GlowPipeline} from "@/shaders/glow";
import {GlowPipeline1} from "@/shaders/glow1";
import {GlowPipeline2} from "@/shaders/glow2";
import {GlowPipeline3} from "@/shaders/glow3";
import {StarsPipeline} from "@/shaders/stars";
import {RainPipeline} from "@/shaders/rain";
import {FogPipeline} from "@/shaders/fog";
import {AmetistShopService} from "@/services/ametist-shop-service";
import {RabbitScroll} from "@/scenes.ui/rabbit-scroll";
import {NewTaskFeedback} from "@/scenes.ui/new-task-feedback";
import {OldRoadLessonService} from "@/services/old-road-lesson-service";
import {IntegrationUtils} from "@/utils/integration-utils";
import QualityUtils from "@/utils/quality-utils";
import {TaskConstants} from "@/constants/task-constants";
import {Reloadable} from "@/scenes/reloadable";
import {PortalShopService} from "@/services/portal-shop-service";
import {ShadowShopService} from "@/services/shadow-shop-service";
import {ForceNotificationService} from "@/services/force-notification-service";
import {PartIntroPanel} from "@/scenes.ui/part-intro-panel";
import {WaterShopService} from "@/services/water-shop-service";
import {HintPanel} from "@/scenes.ui/hint-panel";
import {ChainService} from "@/services/chain-service";
import {SaleService} from "@/services/sale-service";
import {CaviarRankShopService} from "@/services/caviar-rank-shop-service";
import {CaviarElephShopService} from "@/services/caviar-eleph-shop-service";
import {GiftGemsShopService} from '@/services/gift-gems-shop-service';
import {Profile} from '@/store/profile/types';
import {ArtifactTownShopService} from "@/services/artifact-town-service";
import {MonasteryShopService} from "@/services/monastery-shop-service";
import {OblivionShopService} from "@/services/oblivion-shop-serivice";
import {NotifManager} from "@/managers/notif-manager";
import PromoUtils from "@/utils/promo-utils";
import Knight from "@/utils/knight";
import PlayerUtils from "@/utils/player-utils";
import {Gender} from "@/model/gender";
import {YaStorage} from "@/utils/ya-storage";
import SecurityStore from "@/store/security";
import {Http} from "@/constants/http";
import {YaAccPanel} from "@/scenes.ui/ya-acc-panel";
import {BackTriangle} from "@/scenes.ui/back-triangle";
import Scene = Phaser.Scene;
import Image = Phaser.GameObjects.Image;
import Group = Phaser.GameObjects.Group;
import Sprite = Phaser.GameObjects.Sprite;
import GameObject = Phaser.GameObjects.GameObject;
import Container = Phaser.GameObjects.Container;
import Text = Phaser.GameObjects.Text;
import TileSprite = Phaser.GameObjects.TileSprite;
import Graphics = Phaser.GameObjects.Graphics;
import TweenChain = Phaser.Tweens.TweenChain;
import BitmapText = Phaser.GameObjects.BitmapText;
import {TeleportPanel} from "@/scenes.ui/teleport-panel";

export default class RoadScene extends Scene implements Listener, Reloadable {

  @lazyInject(TYPES.HeroShopService)
  private heroShopService!: HeroShopService;

  @lazyInject(TYPES.PlaceService)
  private placeService!: PlaceService;

  @lazyInject(TYPES.GiftService)
  private giftService!: GiftService;

  @lazyInject(TYPES.CustomPlaceService)
  private customPlaceService!: CustomPlaceService;

  @lazyInject(TYPES.RewardService)
  private rewardService!: RewardService;

  @lazyInject(TYPES.RoadLessonService)
  private newLessonService!: RoadLessonService;

  @lazyInject(TYPES.OldRoadLessonService)
  private oldLessonService!: OldRoadLessonService;

  private lessonService!: OldRoadLessonService | RoadLessonService;

  @lazyInject(TYPES.PlayerCreatureService)
  private playerCreatureService!: PlayerCreatureService;

  @lazyInject(TYPES.MenuService)
  private menuService!: MenuService;

  @lazyInject(TYPES.ResourceService)
  private resourceService!: ResourceService;

  @lazyInject(TYPES.SceneService)
  private sceneService!: SceneService;

  @lazyInject(TYPES.ExperienceService)
  private experienceService!: ExperienceService;

  @lazyInject(TYPES.ArtifactService)
  private artifactService!: ArtifactService;

  @lazyInject(TYPES.RuneService)
  private runeService!: RuneService;

  @lazyInject(TYPES.ConsumableService)
  private consumableService!: ConsumableService;

  @lazyInject(TYPES.ShopService)
  private shopService!: ShopService;

  @lazyInject(TYPES.HeroTownShopService)
  private heroTownShopService!: HeroTownShopService;

  @lazyInject(TYPES.ArtifactTownShopService)
  private artifactTownShopService!: ArtifactTownShopService;

  @lazyInject(TYPES.TitanTownShopService)
  private titanTownShopService!: TitanTownShopService;

  @lazyInject(TYPES.AngelTownShopService)
  private angelTownShopService!: AngelTownShopService;

  @lazyInject(TYPES.YotunTownShopService)
  private yotunTownShopService!: YotunTownShopService;

  @lazyInject(TYPES.SurTownShopService)
  private surTownShopService!: SurTownShopService;

  @lazyInject(TYPES.AmetistShopService)
  private ametistShopService!: AmetistShopService;

  @lazyInject(TYPES.WaterShopService)
  private waterShopService!: WaterShopService;

  @lazyInject(TYPES.PortalShopService)
  private portalShopService!: PortalShopService;

  @lazyInject(TYPES.ShadowShopService)
  private shadowShopService!: ShadowShopService;

  @lazyInject(TYPES.ForumService)
  private forumService!: ForumService;

  @lazyInject(TYPES.TaskService)
  private taskService!: TaskService;

  @lazyInject(TYPES.ArtifactNotificationService)
  private artifactNotificationService!: ArtifactNotificationService;

  @lazyInject(TYPES.ForceNotificationService)
  private forceNotificationService!: ForceNotificationService;

  @lazyInject(TYPES.HealthService)
  private healthService!: HealthService;

  @lazyInject(TYPES.CampaignService)
  private campaignService!: CampaignService;

  @lazyInject(TYPES.PlayerSpeedService)
  private playerSpeedService!: PlayerSpeedService;

  @lazyInject(TYPES.ProfileService)
  private profileService!: ProfileService;

  @lazyInject(TYPES.PaymentNotificationService)
  private paymentNotificationService!: PaymentNotificationService;

  @lazyInject(TYPES.GameSoundService)
  private gameSoundService!: GameSoundService;

  @lazyInject(TYPES.GenderChangeService)
  private genderChangeService!: GenderChangeService;

  @lazyInject(TYPES.PaymentChangeService)
  private paymentChangeService!: PaymentChangeService;

  @lazyInject(TYPES.RenamePlayerService)
  private renamePlayerService!: RenamePlayerService;

  @lazyInject(TYPES.MailOrPhoneService)
  private mailOrPhoneService!: MailOrPhoneService;

  @lazyInject(TYPES.PasswordService)
  private passwordService!: PasswordService;

  @lazyInject(TYPES.MagicPlaceService)
  private magicPlaceService!: MagicPlaceService;

  @lazyInject(TYPES.ClanService)
  private clanService!: ClanService;

  @lazyInject(TYPES.ListService)
  private listService!: ListService;

  @lazyInject(TYPES.ChainService)
  private chainService!: ChainService;

  @lazyInject(TYPES.SaleService)
  private saleService!: SaleService;

  @lazyInject(TYPES.CaviarRankShopService)
  private caviarRankShopService!: CaviarRankShopService;

  @lazyInject(TYPES.MonasteryShopService)
  private monasteryShopService!: MonasteryShopService;

  @lazyInject(TYPES.OblivionShopService)
  private oblivionShopService!: OblivionShopService;

  @lazyInject(TYPES.CaviarElephShopService)
  private caviarElephShopService!: CaviarElephShopService;

  @lazyInject(TYPES.LawService)
  private lawService!: LawService;

  @lazyInject(TYPES.LawServiceBeeline)
  private lawServiceBeeline!: LawServiceBeeline;

  @lazyInject(TYPES.RateAppService)
  private rateAppService!: RateAppService;

  @lazyInject(TYPES.IapService)
  private iapService!: IapService;

  @lazyInject(TYPES.TenjinService)
  private tenjinService!: TenjinService;

  @lazyInject(TYPES.AppmetricaService)
  private appmetricaService!: AppmetricaService;

  @lazyInject(TYPES.CapacitorService)
  private capacitorService!: CapacitorService;

  @lazyInject(TYPES.EducationService)
  private educationService!: EducationService;

  @lazyInject(TYPES.GiftGemsShopService)
  private giftGemsShopService!: GiftGemsShopService;

  private readonly WORLD_HORIZON: number = CU.virtualWindowHeight() + 200;
  private KNIGHT_DEFAULT_Y: number = 200;
  private readonly CLICK_FLASH_LIFESPAN: number = 300;
  private readonly KNIGHT_Z_INDEX: number = 1;
  private readonly KNIGHT_SCALE: number = 0.9;
  private readonly CREATURE_OFFSET_X: number = 30;
  private readonly CREATURE_OFFSET_Y: number = 50;
  private readonly DEFAULT_WALKING_FRAMERATE: number = 36;

  private knightPosition: number = this.KNIGHT_DEFAULT_Y;

  /**
  * Для 60 FPS = 16.5ms of delay.
  * Считать рейт по формуле:
   * delay = 1000/fps
  *  */
  private readonly FRAME_RATE_DELAY: number = 16.5;

  private fCounter: number = 0;

  private canvas!: HTMLCanvasElement;

  private goldGroup!: Group;
  private mithrilGroup!: Group;
  private crystalGroup!: Group;
  private elixirGroup!: Group;
  private sulfurGroup!: Group;
  private caviarGroup!: Group;
  private eventCurrencyGroup!: Group;

  private creaturesGroup!: Group;
  private customPlaceGroup!: Group;
  private artifactPlaceGroup!: Group;
  private runePlaceGroup!: Group;
  private consumablePlaceGroup!: Group;
  private pointerPlaceGroup!: Group;
  private turnPlaceGroup!: Group;
  private hideOnMoveGroup!: Group;
  private gainablePlaceGroup!: Group;
  private shadowsGroup!: Group;
  private animations!: Sprite[];
  private lightingGroup!: Group;
  private magicPlaceGroup!: Group;
  private exchangePlaceGroup!: Group;
  private otherGroup!: Group;

  private levels!: (Sprite | BitmapText)[];
  private containers!: Container[];

  private helpMan: Phaser.Sound.BaseSound | undefined;
  private helpWom: Phaser.Sound.BaseSound | undefined;
  private gainLootSound: Phaser.Sound.BaseSound | undefined;
  private horseWalkSound: Phaser.Sound.BaseSound | undefined;
  private mainThemeSound: Phaser.Sound.BaseSound | undefined;
  private placeOpenSound: Phaser.Sound.BaseSound | undefined;
  private awardSound: Phaser.Sound.BaseSound | undefined;
  private buttonClickSound: Phaser.Sound.BaseSound | undefined;
  private creatureClickSound: Phaser.Sound.BaseSound | undefined;
  private levelUpSound: Phaser.Sound.BaseSound | undefined;
  private closeSound: Phaser.Sound.BaseSound | undefined;
  private completedSound: Phaser.Sound.BaseSound | undefined;
  private soundEpic: Phaser.Sound.BaseSound | undefined;

  private actualY: number = 0;
  private direction: number = 1;
  private TOP_MIN_DISTANCE = 250;
  private BOTTOM_MIN_DISTANCE = 250;
  private moveTillY: number = 0;
  private isMoving: boolean = false;
  private isMovingAllowed: boolean = true;

  private lootDisplayedTillY: number = 0;

  private knight!: Sprite;

  private clickFlash!: Sprite;

  private crosshair: Sprite | undefined;

  private mouseIsAllowedToInteract: boolean = true;
  private allBlocked: boolean = false;
  private inDialog: boolean = true;

  private firstStart: boolean = false;

  private menuContainer: Container | undefined;

  private tileRoads: TileRoad[] = [];

  private turnInProgress: boolean = false;

  private stops: Stop[] = [];

  private headerBack: Sprite | undefined;
  private headerText: Text | undefined;
  private worldType!: WorldType;
  private worldStartCoordinate: number | undefined;
  private worldEndCoordinate: number | undefined;
  private waterWorldMode: boolean = false;
  private turnPlaceEduCallback!: (() => unknown) | null;
  private portalId: string | undefined;

  private lastResizeDate: number = 0;

  private minuteOfTheRainActivation!: number;
  private minuteOfTheBirdActivation!: number;
  private effectStatus: EffectStatus = EffectStatus.Stopped;
  private birdStatus: EffectStatus = EffectStatus.Stopped;
  private rainCanGoing: boolean = true;

  private rainPipeline: any;

  get randomMinute() {
    return Math.floor(Math.random() * 30) + 30;
  }

  private darkenPipeline: any;
  private menuNavPanel!: MenuCreaturesNavPanel;
  private eduCallbacks!: EducationServiceCallbacks;
  private herosComments: Map<number, HeroCommentData> =  new Map();
  private currentEducationPanel!: EducationPanelData|null;
  private currentPlacePhrase!: PhrasePanel|null;
  private cryAnimIsPlaying :boolean = false;
  private CONTAINER!: any;
  private isWEBGLRenderer: boolean = true;

  public static logClient(message: string): Promise<void> {
    const params = new URLSearchParams();
    params.append('message', message);
    params.append('domain', `Mobile app ${process.env.VUE_APP_MOBILE_APP_TYPE} v${process.env.VUE_APP_ANDROID_VERSION_CODE}`);
    return http.post('/api/log/add', params);
  }

  // noinspection JSUnusedGlobalSymbols
  init(data: any)  {
    this.firstStart = data ? data.firstStart : false;

    if (IapService.IapEnabled()) {
      this.iapService.initialize(this.tenjinService)
    }
  }

  constructor() {
    super({ key: 'RoadScene' });
  }

  public async preload() {
    this.lastTime = undefined;
    SceneUtils.setCurrentScene(this);
    this.canvas = this.sys.game.canvas;

    let haveSpecialMusic = RoadScene.haveSpecialMusic();

    let loadingText: Text | undefined = undefined;
    if (PlayerStore.getNeedDownload() || haveSpecialMusic) {
      loadingText = TextUtils.addTextByFamily(this, Tr('zagruzka'), this.canvas.width / 2, this.canvas.height - 25,
          '#ffffff', 13, 'normal', CU.CANVAS_WIDTH, Fonts.MYRIADPRO_REGULAR);
    }

    let player = PlayerStore.getPlayer();
    if (haveSpecialMusic) {
      this.load.audio(player.specialMusicKey!, [`assets/sound/ogg/${player.specialMusicKey}.ogg`, `assets/sound/mp3/${player.specialMusicKey}.mp3`]);
    }

    let gender = PlayerUtils.getGender(player);
    let heroLook: HeroLook;
    if (player.heroLook === HeroLook.ACOLYTE) {
      heroLook = HeroLook.ACOLYTE;
    } else if (player.heroLook === HeroLook.HERO || player.controlType === ControlType.BW_FW) {
      heroLook = HeroLook.HERO;
    } else {
      heroLook = HeroLook.HORSE;
    }

    if (player.controlType === ControlType.BW_FW) {
      this.KNIGHT_DEFAULT_Y = CU.virtualWindowHeight() / 2;
    } else {
      this.KNIGHT_DEFAULT_Y = 200;
    }
    this.knightPosition = this.KNIGHT_DEFAULT_Y;

    switch (heroLook) {
      case HeroLook.HORSE:
        if (gender == Gender.female) {
          this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_W, 'assets/anim/knight_idle_w.png', {frameWidth: 101.5, frameHeight: 174.25});
          this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_W, 'assets/anim/knight_walk_w.png', {frameWidth: 75.4, frameHeight: 187});
        } else {
          this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_M, 'assets/anim/knight_walk_m.png', {frameWidth: 75.4, frameHeight: 187.5});
          this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_M, 'assets/anim/knight_idle_m.png', {frameWidth: 101.5, frameHeight: 174.25});
        }
        break;
      case HeroLook.HERO:
        if (gender == Gender.female) {
          this.load.spritesheet('woman_front_idle', 'assets/anim/woman_front_idle.png', {frameWidth: 100, frameHeight: 150});
          this.load.spritesheet('woman_front_walk', 'assets/anim/woman_front_walk.png', {frameWidth: 100, frameHeight: 150});
        } else {
          this.load.spritesheet('man_front_idle', 'assets/anim/man_front_idle.png', {frameWidth: 100, frameHeight: 150});
          this.load.spritesheet('man_front_walk', 'assets/anim/man_front_walk.png', {frameWidth: 100, frameHeight: 150});
        }

        if (player.controlType == ControlType.BW_FW) {
          if (gender == Gender.female) {
            this.load.spritesheet('woman_back_idle', 'assets/anim/woman_back_idle.png', {frameWidth: 100, frameHeight: 150});
            this.load.spritesheet('woman_back_walk', 'assets/anim/woman_back_walk.png', {frameWidth: 100, frameHeight: 150});
          } else {
            this.load.spritesheet('man_back_idle', 'assets/anim/man_back_idle.png', {frameWidth: 100, frameHeight: 150});
            this.load.spritesheet('man_back_walk', 'assets/anim/man_back_walk.png', {frameWidth: 100, frameHeight: 150});
          }
        }
        break;

      case HeroLook.ACOLYTE:
        this.load.spritesheet("acolyte_front_idle", 'assets/anim/acolyte_front_idle.png', {
          frameWidth: 140,
          frameHeight: 140
        });
        this.load.spritesheet("acolyte_front_walk", 'assets/anim/acolyte_front_walk.png', {
          frameWidth: 74,
          frameHeight: 199
        });
        break;
    }

    if (loadingText) {
      loadingText.destroy();
    }

    ArtifactUtils.loadArtifacts(this);
    CU.checkCanvasSize(this, () => {});
  }

  private static fadeBlackout: boolean = true;

  public create(): void {
    this.knightPosition = this.KNIGHT_DEFAULT_Y;
    this.direction = 1;
    let player = PlayerStore.getPlayer();
    if (!!player) {
      if (player.defaultWorld === DefaultWorld.SAND) {
        Settings.KNIGHT_OFFSET_X = 7;
      } else {
        Settings.KNIGHT_OFFSET_X = 0;
      }
    }

    if (this.minuteOfTheRainActivation == undefined) {
      this.minuteOfTheRainActivation = this.game.loop.startTime + (90 * 60 * 1000);
    }

    if (this.minuteOfTheBirdActivation == undefined) {
      this.minuteOfTheBirdActivation = this.game.loop.startTime + (30 * 1000);
    }

    if (player.versionStart && player.versionStart >= 2) {
      this.lessonService = this.newLessonService;
    } else {
      this.lessonService = this.oldLessonService;
    }

    this.eduCallbacks = {
      createDelayedCall: ((delayTime: number, callback: () => unknown) => {
        return this.time.delayedCall(delayTime, callback);
      }).bind(this),
      getActualY: this.getActualY.bind(this),
      killHeroComments: this.killHerosComments.bind(this),
      createHeroComment: this.showHerosComment.bind(this),
      createArrowAnim: this.showArrow.bind(this),
      createHandAnim: this.showHandAnimations.bind(this),
      stopMoving: this.stopMoving.bind(this),
      setMouseDisable: this.setMouseDisable.bind(this),
      getEducationPanel: this.getEducationPanel.bind(this),
      getEduWithButton: this.getEducationPanelWithButton.bind(this),
      launchScript: this.runSpecialCommand.bind(this)
    };

    if (this.turnPlaceEduCallback) {
      this.turnPlaceEduCallback();
      this.turnPlaceEduCallback = null;
    }

    this.isWEBGLRenderer = this.game.renderer.type === 2;

    if (QualityUtils.getQuality() !== Quality.HIGH && QualityUtils.getQuality() !== Quality.STANDARD) {
      this.isWEBGLRenderer = false;
    }

    if (GameState.loadingType === PriorityType.ROAD) {
      LoadUtils.prioritizedLoad(this, PriorityType.ROAD);
      GameState.loadingType = undefined;
    }

    let self = this;

    this.turnInProgress = false;
    this.stops = [];

    if (RoadScene.fadeBlackout) {
      this.sceneService!.fadeBlackout(this, this.canvas!.width, this.canvas!.height);
    }
    RoadScene.fadeBlackout = true;

    if (this.isWEBGLRenderer) {
      const renderer = this.renderer as Phaser.Renderer.WebGL.WebGLRenderer;
      if (renderer && renderer.pipelines) {
        renderer.pipelines.add('DarkenPipeline', new DarkenPipeline(this.game));
        renderer.pipelines.add('GlowPipelineBlue', new GlowPipeline(this.game, {
          x: 0.2,
          y: 0.1,
          z: 0.4
        }, 2000, 89.44, 1.2));
        renderer.pipelines.add('GlowPipelineYellow', new GlowPipeline(this.game, {
          x: 0.7,
          y: 0.4,
          z: 0.01
        }, 4000, 10, 1.0));
        renderer.pipelines.add('GlowPipeline1', new GlowPipeline1(this.game));
        renderer.pipelines.add('GlowPipeline2', new GlowPipeline2(this.game));
        renderer.pipelines.add('GlowPipeline3', new GlowPipeline3(this.game));
        renderer.pipelines.add('StarsPipeline', new StarsPipeline(this.game, 17, 2, 0.05, 0.0));
        this.rainPipeline = renderer.pipelines.add('RainPipeline', new RainPipeline(this.game));
        renderer.pipelines.add('FogPipeline', new FogPipeline(this.game));
        this.darkenPipeline = renderer.pipelines.add('DarkenPipeline', new DarkenPipeline(this.game));
      }
    }

    this.creaturesGroup = this.add.group();
    this.customPlaceGroup = this.add.group();
    this.artifactPlaceGroup = this.add.group();
    this.runePlaceGroup = this.add.group();
    this.consumablePlaceGroup = this.add.group();
    this.pointerPlaceGroup = this.add.group();
    this.turnPlaceGroup = this.add.group();
    this.hideOnMoveGroup = this.add.group();
    this.gainablePlaceGroup = this.add.group();
    this.shadowsGroup = this.add.group();
    this.lightingGroup = this.add.group();
    this.magicPlaceGroup = this.add.group();
    this.exchangePlaceGroup = this.add.group();
    this.otherGroup = this.add.group();
    this.animations = [];

    this.levels = [];
    this.containers = [];

    this.goldGroup = this.createResourceGroup(ResourceType.GOLD);
    this.mithrilGroup = this.createResourceGroup(ResourceType.MITHRIL);
    this.crystalGroup = this.createResourceGroup(ResourceType.CRYSTAL);
    this.elixirGroup = this.createResourceGroup(ResourceType.ELIXIR);
    this.sulfurGroup = this.createResourceGroup(ResourceType.SULFUR);
    this.caviarGroup = this.createResourceGroup(ResourceType.CAVIAR);
    this.eventCurrencyGroup = this.createResourceGroup(ResourceType.EVENT_CURRENCY);

    if (IntegrationUtils.isKongUser()) {
      if (!GameState.PAYMENTS_CHECKED) {
        this.paymentNotificationService.checkPayments();
        GameState.PAYMENTS_CHECKED = true;
      }
    } else {
      this.paymentNotificationService.checkPayments();
    }

    this.actualY = PlayerStore.getCoordinate();
    this.TOP_MIN_DISTANCE = player.knightOffsetTop;
    this.BOTTOM_MIN_DISTANCE = player.knightOffsetBottom;

    this.worldType = player.worldType;
    if (player.worldType === WorldType.CLAN_RAID) {
      this.worldStartCoordinate = this.actualY;
      this.worldEndCoordinate = player.worldEndCoordinate;
    } else {
      this.worldStartCoordinate = undefined;
      this.worldEndCoordinate = undefined;
      if (this.headerText) {
        this.headerText.setVisible(false);
        this.headerText.destroy();
        this.headerText = undefined;
      }
      if (this.headerBack) {
        this.headerBack.setVisible(false);
        this.headerBack.destroy();
        this.headerBack = undefined;
      }
    }

    this.playerSpeedService.init(this);

    this.setupMusic(player);

    if (player.level < 2) {
      if (Settings.LANG_TYPE === Lang.RU) {
        this.helpMan = SoundUtils.addSound(this, Keys.SOUND_HELP_MAN_RU);
        this.helpWom = SoundUtils.addSound(this, Keys.SOUND_HELP_WOM_RU);
      } else {
        this.helpMan = SoundUtils.addSound(this, Keys.SOUND_HELP_MAN_EN);
        this.helpWom = SoundUtils.addSound(this, Keys.SOUND_HELP_WOM_EN);
      }
    }
    this.gainLootSound = SoundUtils.addSound(this, Keys.SOUND_GAIN_LOOT);
    this.horseWalkSound = SoundUtils.addSound(this, Keys.SOUND_HORSE_WALK);
    this.placeOpenSound = SoundUtils.addSound(this, Keys.SOUND_PLACE_OPEN, {volume: Settings.SHORT_TRACK_VOLUME});
    this.awardSound = SoundUtils.addSound(this, Keys.SOUND_AWARD, {volume: Settings.SHORT_TRACK_VOLUME});
    this.soundEpic = SoundUtils.addSound(this, Keys.SOUND_VICTORY_2, {volume: Settings.MUSIC_VOLUME});
    this.buttonClickSound = SoundUtils.addSound(this, Keys.SOUND_BUTTON_CLICK, {volume: Settings.SHORT_TRACK_VOLUME});
    this.creatureClickSound = SoundUtils.addSound(this, Keys.SOUND_CREATURE_CLICK, {volume: Settings.SHORT_TRACK_VOLUME});
    this.levelUpSound = SoundUtils.addSound(this, Keys.SOUND_LEVEL_UP);
    this.closeSound = SoundUtils.addSound(this, Keys.SOUND_SELECT);
    this.completedSound = SoundUtils.addSound(this, Keys.SOUND_COMPLETED);
    //this.sound.pauseOnBlur = true;

    this.tileRoads = [];
    this.setupTiles();

    this.moveTillY = this.actualY;
    this.lootDisplayedTillY = PlayerStore.getPlayer().controlType === ControlType.BW_FW ? PlayerStore.getMinCoordinate() : this.actualY;
    this.syncCoordinate();
    this.mouseIsAllowedToInteract = true;
    this.isMovingAllowed = true;

    Knight.createAnims(this, player, this.playerSpeedService.getSpeedMultiplier() * self.direction);
    if (!GameState.ANIMS_LOADED) {
      AnimationUtils.createAnimation(this, Keys.LOADING_ANIM);
      GameState.ANIMS_LOADED = true;
    }

    this.knight = SpriteUtils.addSpriteN(this, self.canvas!.width / 2 + Settings.KNIGHT_OFFSET_X, self.canvas!.height - this.knightPosition * CU.S, Knight.getKinghtIdle(true));
    SpriteUtils.scale(this.knight, this.KNIGHT_SCALE);
    Knight.play(this.knight, false, this.direction > 0);

    this.knight.setDepth(this.KNIGHT_Z_INDEX);

    SoundUtils.setLooped(this.mainThemeSound);
    SoundUtils.play(this.mainThemeSound);



    this.menuContainer = this.menuService.createMenu(this, this.canvas, true,
      (sceneName: SceneName, params: any) => this.switchSceneWithClouds(sceneName, params, "creatureScene"),
      () => OnceCaller.doOnce("navMenu", () => this.openShop(false, TabName.HERO)),
      () => OnceCaller.doOnce("navMenu", () => this.openShop(false, TabName.BANK)),
      () => OnceCaller.doOnce("navMenu", () => this.openTasks()),
      () => OnceCaller.doOnce("navMenu", () => this.openProfile(PlayerStore.getPlayer().id)),
      () => OnceCaller.doOnce("navMenu", () => this.openArena()),
      () => OnceCaller.doOnce("navMenu", () => this.openClan()),
      () => OnceCaller.doOnce("navMenu", () => this.openForum()),
      () => OnceCaller.doOnce("navMenu", () => this.openHint()),
        (chainId: number, chainCont: Container) => OnceCaller.doOnce("navMenu", () => this.openChain(chainId, chainCont)),
        (saleId: string) => OnceCaller.doOnce("navMenu", () => this.openSale(saleId)),
        (accCont: Container) => OnceCaller.doOnce("yaAccCont", () => this.remapYandex(accCont)));

    this.menuNavPanel = this.children.getByName("menuNavPanel") as MenuCreaturesNavPanel;

    ListenerManager.setOpenTopicCallback((topicId: number) => {
      self.openTopic(topicId);
    });

    if (process.env.VUE_APP_CAS_ENABLED === 'true') {
      this.lawService.open(this, this.canvas, this.tenjinService, this.appmetricaService)
    }

    this.getLessonService().showRoadLesson(this, this.canvas, self.actualY, this.buttonClickSound, (enabled: boolean) => {
      this.mouseIsAllowedToInteract = enabled;
    }, () => {
      this.isMoving = false;
    }, (allowed: boolean) => {
      this.isMovingAllowed = allowed;
    }, (isLessonShowing: boolean) => this.menuService.setMenuButtonsInteractions(isLessonShowing),
        this.menuService, this.playerCreatureService);

    this.experienceService.setSceneAndCanvas(this, this.canvas, this.awardSound, this.creatureClickSound,
        (enabled: boolean) => {
      if (enabled && !self.inDialog) {
        this.mouseIsAllowedToInteract = enabled;
      }
      this.isMoving = false;
    }, player.interfaceMode);

    this.artifactNotificationService.setupScheduledTask();
    this.forceNotificationService.setupScheduledTask();
    this.paymentNotificationService.init(() => this.showBonusPointsManual(), this.appmetricaService,
        this.completedSound!, this.buttonClickSound!);

    let popupCampaignCallback = ()=>{
      if (PlayerStore.getUnseenCampaign()){
        this.campaignService.giveCampaignPanel(this, this.canvas, PlayerStore.getUnseenCampaign(),(tabName: TabName) => {
          this.openShop(false, tabName);
        }, this.buttonClickSound);
        PlayerStore.SET_UNSEEN_CAMPAIGN(undefined);
      }
    }

    if (player.todayAward > 0) {
      this.rewardService.giveEverydayReward(this, this.canvas!, player, this.awardSound, this.buttonClickSound, popupCampaignCallback);
    } else {
      popupCampaignCallback();
    }

    if(PlayerStore.haveAnyReferralBonus()){
      this.rewardService.giveReferralReward(this, this.canvas!, PlayerStore.getReferralBonus()!, player, this.awardSound, this.buttonClickSound, popupCampaignCallback);
    }

    this.healthService.initHealthTimer(this, this.canvas, () => this.openShop(true, TabName.BANK),
        this.buttonClickSound, this.levelUpSound, this.awardSound, (y: number) => {
          if (PlayerStore.getPlayer().interfaceMode === InterfaceMode.ORIGINAL) {
            this.experienceService.changeChildrenPosition(y);
          }
    }, player.interfaceMode);

    this.campaignService.initCampaignButtons(this, this.canvas, (tabName: TabName) => {
        this.openShop(false, tabName);
      }, (creatureId: string) => {
        this.listService.showManual(this, this.canvas, creatureId, () => {});
      }, this.buttonClickSound, this.completedSound);

    ListenerManager.setProfileCallback((playerId: number) => this.openProfile(playerId));
    ListenerManager.setClanDetailsCallback((ci: ClanShortInfo) => this.openClanDetailsPanel(ci));

    this.gameSoundService.init(this);

    if (process.env.VUE_APP_IS_MOBILE_APP === 'true') {
      this.capacitorService.setGameSoundSource(this.gameSoundService)
    }

    this.lastTime = Date.now();

    if (player.roadNews === RoadNews.PART_6) {
      let ip: PartIntroPanel = new PartIntroPanel(this, this.canvas, player.lang, 6, () => {
        ip.close();
        SoundUtils.play(self.buttonClickSound);
        PlayerStore.resetRoadNews();
      });
      SoundUtils.play(self.soundEpic);
      ip.openAnimated();
    } else if (player.roadNews === RoadNews.PART_2) {
      let ip: SoloIntroPanel = new SoloIntroPanel(this, this.canvas, Tr('news.p2.title'), Tr('news.p2.subtitle'),
          Keys.ATLAS_PLACES_2, 'elder_tent', Tr('news.p2.1'), Tr('news.p2.2'), () => {
            ip.close();
            PlayerStore.resetRoadNews();
          });
      ip.openAnimated();
    } else if (player.roadNews === RoadNews.CUSTOM && Version.VERSION_NUM >= player.newsFrontVersion) {
      PlayerStore.getCustomNews().then((txt: string) => {
        let ip: NewsPanel = new NewsPanel(this, this.canvas, Tr('news'), txt, () => {
          ip.close();
          SoundUtils.play(self.buttonClickSound);
          PlayerStore.resetRoadNews();
        });
        ip.openAnimated();
      });
    } else
      if (player.roadNews === RoadNews.ASK_RATE) {
      PlayerStore.setRated();
      // @ts-ignore
      if (window.ysdk) {
        // @ts-ignore
        window.ysdk.feedback.canReview()
            .then(({value, reason}: any) => {
              if (value) {
                this.rateAppService.open(this, this.canvas, AppRateType.YANDEX, () => {
                  // @ts-ignore
                  window.ysdk.feedback.requestReview()
                      .then(({feedbackSent}: any) => {
                        // do nothing
                      });
                });
              } else {
                // do nothing
              }
            });
      } else if (process.env.VUE_APP_IS_MOBILE_APP === 'true') {
        this.rateAppService.open(this, this.canvas, AppRateType.ANDROID_GOOGLE, () => {
          // this.capacitorService.getAppInfo().then((appinfo: AppInfo) => {
          //   window.location.href = `market://details?id=${appinfo.id}`;
          // })
        });
      } else if (IntegrationUtils.isRustoreUser()) {
        IntegrationUtils.showRustoreRateWindow();
      }
    }

    if (player.notification === Notification.BONUS_POINTS) {
      let prp: PointsReminderPanel = new PointsReminderPanel(this, this.canvas,
          () => this.showBonusPointsManual(), () => this.openShop(false, TabName.BANK));
      prp.openAnimated();
    }

    if (player.giftNews === GiftNews.FOTOSTRANA) {
      if (player.userSource === UserSource.foto) {
        let ip: SoloIntroPanel = new SoloIntroPanel(this, this.canvas, Tr('gft'), Tr('gft.by.fotostrana'),
            undefined, Keys.IC_100_MITHRIL, Tr('gft.fotostrana.text'), Tr('with.us'), () => {
              ip.close();
              PlayerStore.takeFotoGift();
            });
        ip.openAnimated();
      } else if (player.userSource === UserSource.mystore) {
        let ip: SoloIntroPanel = new SoloIntroPanel(this, this.canvas, Tr('gft'), Tr('gft.by.vk'),
            undefined, Keys.IC_100_MITHRIL, Tr('gft.by.text'), Tr('with.us'), () => {
              ip.close();
              PlayerStore.takeMystoreGift();
            });
        ip.openAnimated();
      }
    }

    if (!Settings.LOGGED_GAME_STARTED) {
      Settings.LOGGED_GAME_STARTED = true;
      PlayerStore.logGameStarted(true);
    }

    this.giftService.initGiftButton(this, this.canvas, this.buttonClickSound, this.completedSound, (playerId: number) => {
      self.openProfile(playerId);
    });

    if (player.userSource === UserSource.own) {
      if (player.giftNews !== GiftNews.NO_NEWS) {
        let count = Tr('thirty.emeralds');
        switch (player.giftNews) {
          case GiftNews.GEMS_30:
            break;
          case GiftNews.GEMS_100:
            count = Tr('hundred.emeralds');
            break;
          case GiftNews.GEMS_500:
            count = Tr('five.hundred.emeralds');
            break;
          case GiftNews.GEMS_1000:
            count = Tr('thousand.emeralds');
            break;
        }
        let ip: SoloIntroPanel = new PromoSoloPanel(this, this.canvas, Tr('gft'), Tr('gft.by.code'),
            undefined, Keys.IC_100_MITHRIL, Tr('gft.by.code.text') + count + Tr('gft.by.code.text2'), Tr('with.love'), () => {
              ip.close();
              PlayerStore.takeOwnPromoGift();
            });
        ip.openAnimated();
      }
    }

    if(player.blockTillRename){
      this.renamePlayerService.open(this, this.canvas);
    }

    ListenerManager.addPlayerListener(this);

    this.handleNotifs();
    ListenerManager.setNotifCallback(() => self.handleNotifs());

    if (!GameState.YA_PROMO_CHECKED && IntegrationUtils.isYandexUser()) {
      try {
        // @ts-ignore
        window.ysdk.bonuses.getPlayerBonuses().then((obj: any) => {
          try {
            if (!!obj && obj.hasOwnProperty('signature')) {
              PromoUtils.handleYaPromocode(obj.signature);
            }
          } catch (ignore) {}
        });
      } catch (ignore) {}
      GameState.YA_PROMO_CHECKED = true;
    }
  }

  public handleNotifs() {
    NotifManager.checkNotifs(this, this.canvas);
  }

  public onChange(): void {
    this.educationService.checkMarkerTriggers();
  }

  private lastTime: number | undefined = undefined;

  public update(time: number, delta: number): void {
    this.isWEBGLRenderer && this.rainCanGoing && this.applyRainSystem();
    this.applyBirdSpawnSystem();

    ++this.fCounter;
    if (this.lastTime) {
      delta = Math.min(45, Date.now() - this.lastTime);
      delta = Math.max(1, delta);
    }
    let self = this;
    this.lastTime = Date.now();

    self.educationService.checkTopDistanceTriggers(self.canvas.height, self.actualY);
    self.educationService.checkBottomDistanceTriggers(self.actualY);
    self.educationService.checkDelayTriggersPositions(self.actualY);

    if(CampaignWheelPanel2.singleton && CampaignWheelPanel2.singleton.visible){
      CampaignWheelPanel2.singleton.update();
    }

    ListenerManager.callUpdateListeners();
    if (this.isMoving) {
      if (this.moveTargetReached()) {

        // Когда уже добрались до назначенной координаты, обновляем положение игрока на сервере:
        this.syncCoordinate();
        this.isMoving = false;        
        if (this.rainPipeline ) this.rainPipeline.speed = 8;
        Knight.play(this.knight, false, this.direction > 0);
        SoundUtils.stop(this.horseWalkSound);

        this.destroyCrosshairSprite();

      } else {
        if (this.effectStatus === EffectStatus.Going && this.rainPipeline) this.rainPipeline.speed = 8 + 2.22 * this.playerSpeedService.getPlayerSpeedByMultiplier();

        for (let stop of this.stops) {
          if (this.actualY + this.knightPosition * 1.5 + 100 >= stop.coordinate) {
            stop.action();
            return;
          }
        }

        let self = this;

        if (this.fCounter % 10 === 0) {
          self.updateRemainKmText();
        }
        if (this.worldType === WorldType.CLAN_RAID && (!this.worldEndCoordinate || this.actualY > this.worldEndCoordinate)) {
          this.moveTillY = this.actualY;
          this.isMoving = false;
          this.syncCoordinate();
          let ip: InfoPanel = new InfoPanel(this, this.canvas, Tr('konets.puti'), Tr('home'),
              Tr('izza.nizkogo.atmosfernogo.davlenija'), () => {
                OnceCaller.doOnce('toNativeWorld', () => {
                  self.placeService.endClanRaid(true, () => {
                    self.actualY = PlayerStore.getCoordinate();
                    self.switchScene(SceneName.ROAD_SCENE, {});
                  });
                });
              });
          ip.openAnimated();
          return;
        }

        // Пока не добрались до назначенной точки, продолжаем двигаться:

        // Чем ниже фреймрейт - тем быстре будет нагонять скорость
        // Например, для 30 фпс скорость увеличится в 2 раза от эталонных 60 фпс

        if ((this.direction > 0 && this.actualY + this.canvas.height / CU.S + 5 >= PlayerStore.getMaxCoordinate())
            || (this.direction < 0 && this.actualY - 5 < PlayerStore.getMinCoordinate())) {

          this.knightPosition += this.getDistanceDelta(delta);
          this.knight.y = self.canvas!.height - this.knightPosition * CU.S;

        } else {
          this.actualY += this.getDistanceDelta(delta);

          for (let t of this.tileRoads) {
            if (t.tileSprite) {
              if ((t.yTo && t.yTo * CU.S < this.actualY * CU.S + this.canvas.height) || t.yFrom >= this.actualY) {
                t.tileSprite.y += this.getObjectsDelta(delta);
              } else {
                // FIXME HERE
                t.tileSprite.tilePositionY -= this.getDistanceDelta(delta);
                continue;
              }
            } else if (t.sprite) {
              t.sprite.y += this.getObjectsDelta(delta);
            }

            // Если текстура ушла под экран, удаляем её:
            if (t.yTo && t.yTo < this.actualY - 200) {
              if (t.tileSprite) {
                t.tileSprite.destroy();
              }
              if (t.sprite) {
                t.sprite.destroy();
              }
              this.tileRoads = this.tileRoads.filter(obj => obj !== t);
            }
          }

          this.getLessonService().updatePosition(this.actualY);

          if (this.crosshair) {
            this.crosshair.y += this.getObjectsDelta(delta);
          }

          this.shiftGroup(this.goldGroup, delta);
          this.shiftGroup(this.mithrilGroup, delta);
          this.shiftGroup(this.sulfurGroup, delta);
          this.shiftGroup(this.caviarGroup, delta);
          this.shiftGroup(this.elixirGroup, delta);
          this.shiftGroup(this.crystalGroup, delta);

          this.shiftGroup(this.creaturesGroup, delta);
          this.shiftGroup(this.customPlaceGroup, delta);
          this.shiftGroup(this.runePlaceGroup, delta);
          this.shiftGroup(this.gainablePlaceGroup, delta);
          this.shiftGroup(this.shadowsGroup, delta);
          this.shiftGroup(this.artifactPlaceGroup, delta);
          this.shiftGroup(this.consumablePlaceGroup, delta);
          this.shiftGroup(this.pointerPlaceGroup, delta);
          this.shiftGroup(this.turnPlaceGroup, delta);
          this.shiftGroup(this.lightingGroup, delta);
          this.shiftGroup(this.magicPlaceGroup, delta);
          this.shiftGroup(this.exchangePlaceGroup, delta);
          this.shiftGroup(this.otherGroup, delta);

          for (let anim of this.animations) {
            anim!.y += this.getObjectsDelta(delta);
            if (anim.y > this.canvas.height + anim.height) {
              anim.destroy();
              this.animations = this.animations.filter(a => a !== anim);
            }
          }

          for (let sp of this.levels) {
            sp!.y += this.getObjectsDelta(delta);
            if (sp.y > this.canvas.height + 250 && PlayerStore.getPlayer().controlType !== ControlType.BW_FW) {
              this.levels = this.levels.filter(a => a !== sp);
              sp.destroy();
            }
          }

          for (let sp of this.containers) {
            if (sp) {
              sp!.y += this.getObjectsDelta(delta);
              if (sp.y > this.canvas.height + 250 && PlayerStore.getPlayer().controlType !== ControlType.BW_FW) {
                this.containers = this.containers.filter(a => a !== sp);
                sp.destroy();
              }
            } else {
              console.log('WHATTTT');
            }
          }

          this.hideOnMoveGroup.children.iterate((obj) => {
            self.hideOnMoveGroup.killAndHide(obj);
            return true;
          });
        }
        Knight.play(this.knight, true, this.direction > 0);
        if (!Knight.isWalking(this.knight)) {
          SoundUtils.setLooped(this.horseWalkSound);
          SoundUtils.play(this.horseWalkSound);
        }
      }
    } else {
      // Если открыли spellbook или соблюдается другое условие,
      // когда движение персонажа запретили
      // просто останавливаем анимацию и звук движения и удаляем спрайт crosshair
      Knight.play(this.knight, false, this.direction > 0);
      SoundUtils.stop(this.horseWalkSound);
      this.destroyCrosshairSprite();
    }

    if (this.lootBoundaryReached()) {
      // Если замаячил конец зоны с лутом, запрашиваем и расставляем лут (генерим мир впереди игрока)
      let self = this;
      let displayTill = this.lootDisplayedTillY + this.WORLD_HORIZON;
      if (this.placeService.isPlacesLoaded() && displayTill > PlaceService.getMaxLoadedCoordinate() && this.lootDisplayedTillY < PlaceService.getMaxLoadedCoordinate()) {
        displayTill = PlaceService.getMaxLoadedCoordinate();
      }

      if (this.effectStatus === EffectStatus.Going && this.rainCanGoing) this.toggleWeatherEffect(true, "RainPipeline");

      let player: Player = PlayerStore.getPlayer();
      if (this.placeService.isPlacesLoaded() && displayTill <= PlaceService.getMaxLoadedCoordinate()) {
        this.getLessonService().onPlacesLoaded(self.actualY);

        let educations: Education[] = PlaceStore.getEducations();
        this.educationService.createMarkerEducation(educations, this.eduCallbacks);
        this.educationService.checkMarkerTriggers();

        let places: Place[] = PlaceStore.getPlaces(this.lootDisplayedTillY, displayTill);
        places.forEach(p => {
          let x = p.posX;
          let y = self.canvas.height / CU.S - (p.posY - self.actualY);
          let offsetX = this.CREATURE_OFFSET_X;
          let offsetY = this.CREATURE_OFFSET_Y;
          self.getLessonService().addPlace(p, self.actualY);

          if (p.educations) {
            const PLACE_CANVAS_Y = self.educationService.worldYToCanvasY(p.posY, self.actualY, CU.CANVAS_HEIGHT);

            if (PLACE_CANVAS_Y < CU.CANVAS_HEIGHT - 50) {
              for (let _ of p.educations) {
                self.educationService.createEducationTrigger(p, self.eduCallbacks);
              }
            }
          }

          p.accept(new class implements PlaceVisitor {

            visitGainablePlace(place: GainablePlace): void {
              let rp: any;
              if (Keys.ADDITIONAL_GAINABLES.includes(place.placeId)) {
                rp = SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, place.placeId);
              } else if (Keys.EVENT_GAINABLES.includes(place.placeId)) {
                rp = SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, Keys.ATL_EVENT_GAINABLE, place.placeId);
              } else if (place.placeId == TaskConstants.TASK_BIRTHDAY_HAT) {
                let chosenHat = Keys.BIRTHDAY_HATS[Math.floor(RandomUtils.getSeededRandom(place.posY) * Keys.BIRTHDAY_HATS.length)];
                rp = SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, Keys.ATLAS_PLACES_BIRTHDAY, chosenHat);
              } else if (place.placeId == TaskConstants.TASK_BIRDS_FOR_MUSHROOM) {
                let chosenBird = Keys.BIRDS_FOR_MUSHROOM[Math.floor(RandomUtils.getSeededRandom(place.posY) * Keys.BIRDS_FOR_MUSHROOM.length)];
                rp = SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, chosenBird);
              } else if (place.placeId == TaskConstants.TASK_FLOWER_FOR_WREATH) {
                let chosenFlower = Keys.FLOWERS_FOR_WREATH[Math.floor(RandomUtils.getSeededRandom(place.posY) * Keys.FLOWERS_FOR_WREATH.length)];
                rp = SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, chosenFlower);
              } else {
                rp = KeysNoLoad.GAINABLES_ATLAS_2.includes(place.placeId)
                    ? SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, Keys.ATLAS_GAINABLE_2, place.placeId)
                    : SpriteUtils.groupCreate(self, self.gainablePlaceGroup, x, y, Keys.ATLAS_GAINABLE, place.placeId);
              }

              if (place.creatureId) {
                self.isWEBGLRenderer ? rp.setPipeline("DarkenPipeline") : rp.setAlpha(0.7);
              }

              rp.setInteractive().on('pointerup', () => {
                self.gainablePlaceCallback(self, place, rp, p);
              });
            }

            visitPointerPlace(place: PointerPlace): void {
              let pp = SpriteUtils.groupCreate(self, self.pointerPlaceGroup, x, y, AtlasUtils.getPointerAtlas(place.imageId), place.imageId);

              pp.setInteractive().on('pointerup', () => {
                self.pointerPlacePlaceCallback(self, place);
              });
            }

            visitTurnPlace(place: TurnPlace): void {
              self.turnPlaceEduCallback = self.educationService
                            .onCompleteTrigger(place.educations, place, self.eduCallbacks);

              offsetX = 0;
              offsetY = 20;

              if (place.creatureId && place.lighting) {
                self.createPlaceLighting(x + place.lightingX, y + offsetY + place.lightingY, 0.8);
                self.createPlaceArrow(x + place.lightingX, y - 70 + place.lightingY, 0.25);
              }
              let rect = self.add.rectangle(x * CU.S, y * CU.S, 220 * CU.S, 140 * CU.S);
              rect.setOrigin(0.5, 0.5).setDepth(1);

              let cross: GameObject | undefined = undefined;

              rect.setInteractive().on('pointerup', (pointer: any) => {
                self.turnPlaceCallback(self, place, p, x, pointer, cross);
              });
              self.turnPlaceGroup.add(rect);
            }

            visitArtifactPlace(place: ArtifactPlace): void {
              let shadow = SpriteUtils.groupCreate(self, self.shadowsGroup, x, y+20, Keys.PLACE_SHADOW);
              let ap = SpriteUtils.groupCreate(self, self.artifactPlaceGroup, x, y, place.atlasId, place.imageId);

              if (place.creatureId) {
                self.isWEBGLRenderer ? ap.setPipeline("DarkenPipeline") : ap.setAlpha(0.7);
              }

              SpriteUtils.setDispSize(ap, 64 * CU.S, 64 * CU.S);

              ap.setInteractive().on('pointerup', () => {
                self.artifactPlaceCallback(self, place, p, ap, shadow);
              });
            }

            visitRunePlace(place: RunePlace): void {
              let rp = SpriteUtils.groupCreate(self, self.runePlaceGroup, x, y, place.atlasId, place.imageId);

              if (place.creatureId) {
                self.isWEBGLRenderer ? rp.setPipeline("DarkenPipeline") : rp.setAlpha(0.7);
              }

              rp.setInteractive().on('pointerup', () => {
                self.runePlaceCallback(self, place, p, rp);
              });
            }

            visitResourcePlace(place: ResourcePlace): void {
              const callback: (() => unknown) | null = self.educationService
                          .onCompleteTrigger(place.educations, place, self.eduCallbacks);

              let group = self.getResourceGroup(place.resourceType);
              let newIm = group.get(x * CU.S, y * CU.S);

              if (!place.creatureId && self.isWEBGLRenderer) {
                place.resourceType && newIm.resetPipeline(true);

                if (place.resourceType === ResourceType.MITHRIL) newIm.setPipeline("GlowPipelineBlue");
                else if (place.resourceType === ResourceType.GOLD) newIm.setPipeline("StarsPipeline");
                else if (place.resourceType === ResourceType.CRYSTAL) newIm.setPipeline("StarsPipeline");
                else if (place.resourceType === ResourceType.ELIXIR) newIm.setPipeline("StarsPipeline");
              }
              newIm.setScale(CU.S, CU.S).setAlpha(place.creatureId ? 0.9 : 1);

              if (newIm) {
                newIm.setActive(true).setVisible(true).setScale(CU.S, CU.S);

                if (place.creatureId) {
                  self.isWEBGLRenderer ? newIm.setPipeline("DarkenPipeline") : newIm.setAlpha(0.7);
                }

                newIm.setInteractive().on('pointerup', (pointer: any) => {
                  self.resourcePlaceCallback(self, place, newIm, pointer, group, callback);
                });
              }
            }

            visitCustomPlace(p: CustomPlace): void {
              let offset = self.visitCustomPlace(player, p, self, x, y, offsetX, offsetY);
              offsetX = offset.offsetX;
              offsetY = offset.offsetY;
            }

            visitConsumablePlace(consPlace: ConsumablePlace): void {
              let cons = SpriteUtils.groupCreate(self, self.consumablePlaceGroup, x, y, AtlasUtils.getConsumableShadeAtlas(consPlace.imageId), consPlace.imageId);

              if (consPlace.creatureId) {
                self.isWEBGLRenderer ? cons.setPipeline("DarkenPipeline") : cons.setAlpha(0.7);
              }

              if (consPlace.imageId.startsWith('p4x-')) {
                SpriteUtils.scale(cons, 0.65);
              } else if (!consPlace.imageId.startsWith('p4_')) {
                SpriteUtils.scale(cons, 0.47);
              } else {
                SpriteUtils.scale(cons, 0.8);
              }

              cons.setInteractive().on('pointerup', () => {
                self.consumablePlaceCallback(self, consPlace, p, cons);
              });
            }

            visitScriptPlace(p: ScriptPlace): void {
              switch (p.identifier) {
                case 'forge':
                  let magicPlace = SpriteUtils.groupCreate(self, self.magicPlaceGroup, x, y, 'forge', "");

                  if (p.creatureId) {
                    self.isWEBGLRenderer ? magicPlace.setPipeline("DarkenPipeline") : magicPlace.setAlpha(0.7);
                  }

                  magicPlace.setInteractive().on('pointerup', () => {
                    self.magicPlaceCallback(self, p);
                  });
                  break;
                case 'exchange':
                  let exchangePlace = SpriteUtils.groupCreate(self, self.exchangePlaceGroup, x, y, 'atlas_places_1', 'exchange_inn');

                  if (p.creatureId) {
                    self.isWEBGLRenderer ? exchangePlace.setPipeline("DarkenPipeline") : exchangePlace.setAlpha(0.7);
                  }

                  exchangePlace.setInteractive().on('pointerup', () => {
                    p.educations && self.killEducations(p.id);

                    self.openExchangePanel();
                  });
                  break;
                case 'back':
                  let bt = new BackTriangle(self, x * CU.S, y * CU.S, () => {
                    OnceCaller.doOnce('back_to_rd', () => {
                      self.turnInProgress = true;
                      self.placeService.back(player.contextId, () => {
                        self.actualY = PlayerStore.getCoordinate();
                        self.switchScene(SceneName.ROAD_SCENE, {});
                      });
                    });
                  }, PlayerStore.getMaxCoordinate() > self.actualY + 1000000 ? Tr('back') : Tr('k.doroge'));
                  self.add.existing(bt);
                  self.containers.push(bt);
                  break;
                case 'ship':
                  let rect = self.add.rectangle(x * CU.S, y * CU.S, 120 * CU.S, 290 * CU.S);
                  rect.setOrigin(0.5, 0.5).setDepth(1);
                  self.otherGroup.add(rect);

                  rect.setInteractive().on('pointerup', () => {
                    PlaceStore.fetchTeleportInfo(p.id).then((t: TeleportDto) => {
                      if (!!t && t.destinations.length > 0) {
                        let tp = new TeleportPanel(self, self.canvas, t, Tr('close'), (roadId: string) => {
                          OnceCaller.doOnce('useTelep', () => {
                            self.placeService.useTeleport(p.id, roadId, () => {
                              self.actualY = PlayerStore.getCoordinate();
                              self.switchScene(SceneName.ROAD_SCENE, {});
                            });
                          });
                        }, () => {

                        });
                        tp.openAnimated();
                      } else {
                        let ip = new InfoPanel(self, self.canvas, t.title, t.emptyIntro, t.emptyText, () => {});
                        ip.openAnimated();
                      }
                    });
                  });
              }
            }

            visitPortalPlace(place: PortalPlace) {
              let ap = SpriteUtils.groupCreate(self, self.otherGroup, x, y, place.atlasId, place.imageId, 0.4, 0.4);

              if (place.creatureId) {
                self.isWEBGLRenderer ? ap.setPipeline("DarkenPipeline") : ap.setAlpha(0.7);
              }

              ap.setInteractive().on('pointerup', () => {
                self.openOrAttack(p, () => {
                  self.portalPlaceCallback(self, place);
                });
              });
            }

            visitSkillPlace(place: SkillPlace): void {
              let atlas = place.customAtlas? place.customAtlas : Keys.ATLAS_SKILLS;
              let image = place.customImage? place.customImage : SkillUtils.getPileImage(place.skillType);
              let sp = SpriteUtils.groupCreate(self, self.otherGroup, x, y, atlas, image).setAlpha(p.creatureId ? 0.9 : 1);

              sp.setInteractive().on('pointerup', (pointer: any) => {
                self.skillPlaceCallback(self, place, sp);
              });
            }

            visitTalkerPlace(place: TalkerPlace): void {
              let ap = SpriteUtils.groupCreate(self, self.otherGroup, x, y, place.atlasId, place.imageId);

              let pp: PhrasePanel | undefined = undefined;
              let tc: TweenChain | undefined = undefined;
              ap.setInteractive().on('pointerup', () => {
                if (tc) {
                  tc.stop();
                }
                if (pp) {
                  pp.destroy();
                }
                let phrase = RandomUtils.getRandom(place.phrases);
                pp = new PhrasePanel(self, ap.x, ap.y - 70, 13);
                tc = pp.show(phrase);
              });
            }
          });

          if (p.creatureId !== null) {

            let ca = AnimationUtils.createAnimation(this, p.creatureId);
            if (ca) {
              let animSprite = SpriteUtils.addSprite(self, x + 25, y + 40, p.creatureId);
              animSprite.setOrigin(0.5, 1);
              self.animations.push(animSprite);
              animSprite.play(p.creatureId);
              this.setBlockingCreatureInteractions(animSprite, p.id, p.battleLost, Boolean(p.educations));
            } else {
              if (p.creatureLevel && p.creatureLevel > 300) {
                offsetY += 14;
                offsetX += 9;
              }
              if (self.waterWorldMode) {
                offsetY -= 18;
                offsetX -= 6;
                if ((p.positionType === PositionType.WATER_SMALL || p.positionType === PositionType.WATER_BIG)) {
                  let isl = SpriteUtils.addSprite(self, x + offsetX - 4, y + offsetY + 14, Keys.ATLAS_PLACES_WATER, 'isl');
                  isl.setOrigin(0.5, 1);
                  self.levels.push(isl);
                }
              }
              let creature = SpriteUtils.groupCreate(self, this.creaturesGroup, x + offsetX, y + offsetY,
                  AtlasUtils.getCreatureRoadAtlas(p.creatureId), p.creatureId);
              creature.setOrigin(0.5, 1);
              if (self.waterWorldMode) {
                SpriteUtils.scale(creature, 0.75, 0.75);
              }


              if (p.creatureLevel) {
                // let text: Sprite = TextUtils.addStairText(self, p.creatureLevel, player, creature.x + 20, creature.y - 6);
                // self.levels.push(text);

                let text: BitmapText | undefined = TextUtils.addNumText(self, p.creatureLevel, creature.x / CU.S + 20, creature.y / CU.S - 6, player);
                if (!!text) {
                  self.levels.push(text);
                }
              }
              this.setBlockingCreatureInteractions(creature, p.id, p.battleLost, Boolean(p.educations));
            }
          }

        });
        this.lootDisplayedTillY = displayTill;
      }
    }
  }

  private makeCustomPlace(p:CustomPlace){
    let x = p.posX;
    let y = this.canvas.height / CU.S - (p.posY - this.actualY);
    let offsetX = this.CREATURE_OFFSET_X;
    let offsetY = this.CREATURE_OFFSET_Y;
    this.visitCustomPlace(PlayerStore.getPlayer(), p, this, x, y, offsetX, offsetY);
  }

  private visitCustomPlace(player:Player, p : CustomPlace, self:RoadScene, x:number, y:number, offsetX:number, offsetY:number):{offsetX: number, offsetY:number} {
    p.talks && self.createPlacePhrase(p, p.talks, p.posX, p.posY);
    const callback: (() => unknown) | null = self.educationService
        .onCompleteTrigger(p.educations, p, self.eduCallbacks);

    let lighting: Image | undefined;
    let arrow: Image | undefined;
    let dialogBubble: Image | undefined;
    if (p.lighting) {
      lighting = self.createPlaceLighting(x + p.lightingX, y + p.lightingY + (p.positionType === PositionType.SMALL ? 20 : 30),
          p.positionType === PositionType.BIG ? 2.0 : 1.0);
      arrow = self.createPlaceArrow(x + p.lightingX, y + p.lightingY - (p.positionType === PositionType.SMALL ? 70 : 100),
          p.positionType === PositionType.BIG ? 0.5 : 0.25,  !p.used);
    } else if (p.placeDisplayType == PlaceDisplayType.DIALOG) {
      dialogBubble = self.createPlaceDialogBubble(x + p.lightingX, y - 70 + p.lightingY - (p.positionType === PositionType.BIG ? 20 : 0), 1);
    }

    let stop: Stop | undefined = undefined;
    if(p.placeId == "wq1_leprekon_wolf_2"){
      console.log("mandatory: " + p.mandatory)
      console.log(p)
    }
    if (p.mandatory) {
      stop = new Stop();
      stop.coordinate = p.posY;
      stop.action = () => {
        if (PlaceStore.placeExists(p.id)) {
          self.openCustomPlace(p, po, animSprite, stop, lighting, arrow, dialogBubble);
        }
      };
      self.stops.push(stop);
    }
    if (p.atlasId === 'atlas_places') {
      p.atlasId = 'atlas_places_1'; // hack for backward compatibility, don't remove it.
    }
    let po = self.createCustomPlaceSprite(p, x, y);

    let cp = null;
    if(po.cp) {
      cp = po.cp;

      if (cp && p.placeId.startsWith('p4_boss_')) {
        SpriteUtils.scale(cp, 0.8);
      }
    }

    let animSprite: Sprite | undefined = undefined;
    if (p.animationId) {
      animSprite = SpriteUtils.addAndPlayAnim(self, x, y, p.animationId, self.animations);
    }
    let go = animSprite ? animSprite : cp;
    if (p.positionType === PositionType.BIG) {
      offsetX = offsetX * 1.2;
      offsetY = offsetY * 1.2;
    }

    let dialog: CustomPlaceContainer | undefined = undefined;
    go!.setInteractive().on('pointerdown', () => {
      self.openOrAttack(p, () => {
        p.used = true;
        self.killCurrentPlacePhrase();
        p.educations && self.killEducations(p.id);
        dialog = self.openCustomPlace(p, po, animSprite, stop, lighting, arrow, dialogBubble, false, callback);
        po.cp && po.cp.resetPipeline(true);

        if (dialog && dialog.isSceneDefined()) {
          self.mouseIsAllowedToInteract = false;
          self.inDialog = true;
          self.isMoving = false;
          dialog.openAnimated();
        }
      });
    });
    if (player.autoOpenCustomPlaceId && player.autoOpenCustomPlaceId === p.id) {
      po.cp && po.cp.resetPipeline(true);
      self.openCustomPlace(p, po, animSprite, stop, lighting, dialogBubble, arrow);
    }

    if (p.creatureId) {
      po.cp && self.isWEBGLRenderer ? po.cp.setPipeline("DarkenPipeline") : po.cp.setAlpha(0.7);
    }

    return {offsetX: offsetX, offsetY:offsetY}
  }

  private applyRainSystem(): void {
    if (this.effectStatus === EffectStatus.Stopped
      && (this.game.loop.now - this.minuteOfTheRainActivation) < 30000
      && (this.game.loop.now - this.minuteOfTheRainActivation) > 0) {
      this.effectStatus = Math.floor(Math.random() * 4) === 1 ? EffectStatus.Going : EffectStatus.Sleeping;
      this.effectStatus === EffectStatus.Going && this.rainInAnim();
    }

    if (this.effectStatus === EffectStatus.Going
      && this.minuteOfTheRainActivation + 30000 < this.game.loop.now) {
      this.effectStatus = EffectStatus.Stopped;
      this.minuteOfTheRainActivation = this.game.loop.now + 1 * 60 * 1000;

      this.rainOutAnim();
    } else if (this.effectStatus === EffectStatus.Sleeping
      && this.minuteOfTheRainActivation + 30000 < this.game.loop.now) {
      this.minuteOfTheRainActivation = this.game.loop.now + 1 * 60 * 1000;
    }
  }

  private applyBirdSpawnSystem(): void {
    if (this.birdStatus === EffectStatus.Stopped
      && (this.game.loop.now - this.minuteOfTheBirdActivation) < 30000
      && (this.game.loop.now - this.minuteOfTheBirdActivation) > 0) {
      this.birdStatus = Math.floor(Math.random() * 50) === 1 ? EffectStatus.Going : EffectStatus.Sleeping;
      this.birdStatus === EffectStatus.Going && this.createBird();
    } else if (this.birdStatus === EffectStatus.Sleeping
      && this.minuteOfTheBirdActivation + 30000 < this.game.loop.now) {
      this.minuteOfTheBirdActivation = this.game.loop.now + this.randomMinute / 2 * 1000;
    }
  }

  private gainablePlaceCallback(self: RoadScene, place: GainablePlace, rp: any, p: Place): void {
    self.openOrAttack(place, () => {
      SoundUtils.play(self.gainLootSound);

      self.tweens.add({
        targets: rp,
        alpha: 0,
        duration: 200,
        onComplete() {
          self.gainablePlaceGroup.killAndHide(rp);
        }
      });
      PlaceStore.REMOVE_PLACE(p.id);
      PlaceStore.takeGainable(place.id);
    });
  }

  private pointerPlacePlaceCallback(self: RoadScene, place: PointerPlace): void {
    self.isMoving = false;
                SoundUtils.play(self.buttonClickSound);

                new ImageTextPanel(self, self.canvas, CU.CANVAS_WIDTH / 2, self.canvas!.height / 2 - 25,
                    Tr('ukazatel'), place.comment, AtlasUtils.getPointerAtlas(place.imageId), place.imageId, self.closeSound!)
                    .setDepth(10000).openAnimated();
  }

  private turnPlaceCallback(self: RoadScene, place: TurnPlace, p: Place,
     x: number, pointer: any, cross: GameObject | undefined): void {
    if (self.mouseIsAllowedToInteract || self.educationService.interactiveObjectsHasKey(p.id)) {
      place.educations && self.killEducations(place.id);
      self.isMovingAllowed = true;
      self.allBlocked = false;
      self.mouseIsAllowedToInteract = true;

      if (p.creatureId) {
        SoundUtils.play(self.buttonClickSound);
        new PlaceCreaturePanel(self.scene.scene!, self.canvas!, place, self.closeSound, () => {
          self.attackCreature(p.id);
        }).openAnimated();
      } else {
        self.spawnClickFlashSprite(pointer.position.x, pointer.position.y);
        self.doTurn(self, place, p, x, cross);
      }
    }
  }

  private doTurn(self: RoadScene, place: TurnPlace, p: Place,
                            x: number, cross: GameObject | undefined): void {
    self.isMoving = false;

    let crossY = self.canvas.height - (p.posY - self.actualY) * CU.S - 15 * CU.S;
    if (!cross || !cross.active) {
      cross = SpriteUtils.addSpriteN(self, x * CU.S, crossY, Keys.IMG_CROSSHAIR);
    }
    self.hideOnMoveGroup.add(cross);

    self.turnInProgress = true;
    OnceCaller.doOnce('useTrn', () => {
      self.placeService.turn(place.id, () => {
        self.actualY = PlayerStore.getCoordinate();
        self.switchScene(SceneName.ROAD_SCENE, {});
      });
    });
  }

  private artifactPlaceCallback(self: RoadScene, place: ArtifactPlace, p: Place, ap: any, shadow: any): void {
    self.openOrAttack(place, () => {
      place.educations && self.killEducations(place.id);
      self.artifactService.openPlace(self.scene.scene, self.canvas, place.id, self.awardSound, self.buttonClickSound, (removePlace: boolean) => {
        self.mouseIsAllowedToInteract = true;
        if (removePlace) {
          self.artifactPlaceGroup.killAndHide(ap);
          self.shadowsGroup.killAndHide(shadow);
          PlaceStore.REMOVE_PLACE(p.id);
          self.getLessonService().onTakeArtifact(place);
        }
      },(openUnlockPanel: boolean) => {
        self.sceneService.startSceneWithParamsAndClouds(self, self.canvas, {openUnlockPanel: openUnlockPanel}, SceneName.CREATURE_SCENE,
            self.canvas!.width, self.canvas.height, "creatureScene");
        SoundUtils.stop(self.mainThemeSound);
      });
      self.mouseIsAllowedToInteract = false;
      self.isMoving = false;
      SoundUtils.play(self.placeOpenSound);
    });
  }

  private runePlaceCallback(self: RoadScene, place: RunePlace, p: Place, rp: any): void {
    self.openOrAttack(place, () => {
      place.educations && self.killEducations(place.id);
      self.runeService.openPlace(self.scene.scene, self.canvas, place.id, self.awardSound, self.buttonClickSound, (removePlace: boolean) => {
        self.mouseIsAllowedToInteract = true;
        if (removePlace) {
          self.runePlaceGroup.killAndHide(rp);
          PlaceStore.REMOVE_PLACE(p.id);
        }
      }, () => self.getLessonService().onTakeRune());
      self.mouseIsAllowedToInteract = false;
      self.isMoving = false;
      SoundUtils.play(self.placeOpenSound);
    });
  }

  private resourcePlaceCallback(self: RoadScene, place: ResourcePlace, newIm: any, pointer: any, group: any,
     callback: (() => unknown) | null): void {
    self.openOrAttack(place, () => {
      place.educations && self.killEducations(place.id);
      self.getLessonService().onTakeResource(place);
      SoundUtils.play(self.gainLootSound);
      newIm.removeAllListeners();
      group.killAndHide(newIm);
      self.resourceService.takeResource(self, place, pointer.x, pointer.y);
      self.menuService.showResourcesAddedEffect(place.resourceType, place.count);
      callback && callback();
    });
  }

  private consumablePlaceCallback(self: RoadScene, consPlace: ConsumablePlace, p: Place, cons: any): void {
    self.openOrAttack(consPlace, () => {
      consPlace.educations && self.killEducations(consPlace.id);
      self.consumableService.openPlace(self, self.canvas, consPlace, (removePlace: boolean) => {
        self.mouseIsAllowedToInteract = true;
        if (removePlace) {
          self.consumablePlaceGroup.killAndHide(cons);
          PlaceStore.REMOVE_PLACE(p.id);
        }
      });
      self.mouseIsAllowedToInteract = false;
      self.isMoving = false;
      SoundUtils.play(self.placeOpenSound);
    });
  }

  private magicPlaceCallback(self: RoadScene, place: ScriptPlace): void {
    place.educations && self.killEducations(place.id);

    SoundUtils.play(self.placeOpenSound);

    self.magicPlaceService.openPlace(self, self.canvas, place, () => {
      PlaceStore.setUsed(place.id);
    });
  }

  private portalPlaceCallback(self: RoadScene, place: PortalPlace, discount?:number): void {
    place.educations && self.killEducations(place.id);

    self.moveTillY = self.actualY;
    self.isMoving = false;
    let pp = new PortalPanel(self, self.canvas);
    SoundUtils.play(self.placeOpenSound);
    if(discount === undefined){
      pp.openAnimated();
    } else {
      pp.open();
    }

    PortalStore.info(place.id).then((portal: PortalDto) => {
      self.syncCoordinate();
      pp.init(portal, self.buttonClickSound!, (discount?:number) => {
        let finalPrice = discount ? Math.floor(portal.price.mithril * (100 - discount)/100) : portal.price.mithril;
        if (PlayerStore.getPlayer().mithril < finalPrice) {
          SoundUtils.play(self.levelUpSound);
          self.openShop(true, TabName.BANK);
        } else {
          self.turnInProgress = true;
          SoundUtils.play(self.buttonClickSound);
          OnceCaller.doOnce('usePrtl', () => {
            self.placeService.usePortal(place.id, () => {
              self.actualY = PlayerStore.getCoordinate();
              self.switchScene(SceneName.ROAD_SCENE, {});
            }, discount);
          });
        }
      });
    });
  }

  private skillPlaceCallback(self: RoadScene, place: SkillPlace, sp: any): void {
    self.openOrAttack(place, () => {
      place.educations && self.killEducations(place.id);
      SoundUtils.play(self.gainLootSound);
      sp.removeAllListeners();
      self.otherGroup.killAndHide(sp);
      self.menuService.showCreatureSkillEffect(place.skillType, place.count);
      PlaceStore.takeSkill(place);
    });
  }

  private setMouseDisable(): void {
    this.mouseIsAllowedToInteract = false;
  }

  private setMouseEnable(): void {
    this.mouseIsAllowedToInteract = true;
  }

  private stopMoving(): void{
    this.isMoving = false;
  }

  private getActualY(): number {
    return this.actualY;
  }

  private addContainerToTheRoad(container: Container): void {
    this.containers.push(container);
  }

  private openOrAttack(p: Place, action: () => unknown) {
    if (this.allBlocked) {
      return;
    }
    if (this.mouseIsAllowedToInteract || this.educationService.interactiveObjectsHasKey(p.id)) {
      if (p.creatureId) {
        this.attackCreature(p.id, Boolean(p.educations));
      } else {
        action();
      }
    }
  }

  private createPlaceLighting(x: number, y: number, scale: number): Image {
    const lighting = SpriteUtils.groupCreate(this, this.lightingGroup, x, y, Keys.ATLAS_PROFILE, Keys.UI_ART_SLOT_LIGHT, scale);
    lighting.setAlpha(0);
    this.tweens.chain({
      targets: lighting,
      loop: -1,
      yoyo: true,
      tweens: [{},
        {
          delay: 0,
          duration: 2500,
          alpha: 1.0,
          hold: 750
        }]
    });
    return lighting;
  }

  private createPlaceArrow(x: number, y: number, scale: number, showArrow: boolean = true): Image {
    let cont = new Container(this, x * CU.S, y * CU.S);
    const arrow = SpriteUtils.addSprite(this, 0, -30, Keys.ATLAS_UI, Keys.ARROW_CROSS, scale).setVisible(showArrow);
    this.lightingGroup.add(arrow);
    cont.add(arrow).setDepth(2000);
    this.add.existing(cont);
    this.containers.push(cont);
    arrow.rotation = -1;
    let tc = this.tweens.chain({
      targets: arrow,
      loop: -1,
      yoyo: true,
      tweens: [
        {
          y: 10
        },{
          y: -10
        }]
    });
    return arrow;
  }

  private createPlaceDialogBubble(x: number, y: number, scale: number): Image {
    let cont = new Container(this, x * CU.S, y * CU.S);
    const arrow = SpriteUtils.addSprite(this, 10, -50, Keys.IMG_DIALOG_BUBBLE, undefined, scale);
    this.lightingGroup.add(arrow);
    cont.add(arrow);
    this.add.existing(cont);
    this.containers.push(cont);
    cont.setDepth(2000);
    let tc = this.tweens.chain({
      targets: arrow,
      loop: -1,
      yoyo: true,
      tweens: [
        {
          y: 5,
          duration:1200
        },{
          y: -5,
          duration:1200
        }]
    });
    arrow.visible = false;
    return arrow;
  }

  private setBlockingCreatureInteractions(creature: Sprite, placeId: number, battleLost: boolean, killPlaceEdu?: boolean) {
    let self = this;
    creature.setAlpha(battleLost ? 0.7 : 1);
    creature.setInteractive().on('pointerup', () => {
      this.attackCreature(placeId, killPlaceEdu);
    });
  }

  private attackCreature(placeId: number, killPlaceEdu: boolean = false) {
    if (this.allBlocked) {
      return;
    }
    if (this.mouseIsAllowedToInteract || this.educationService.interactiveObjectsHasKey(placeId)) {
      killPlaceEdu && this.killEducations(placeId);
      let self = this;
      SoundUtils.play(this.creatureClickSound);
      this.mouseIsAllowedToInteract = false;

      let faded = false;
      let responseRecieved = false;

      this.stopEverithingInScene();

      let blackout: {group: Group, graphics:Graphics} | Graphics | undefined = self.sceneService.fadeInClouds(this, this.canvas, this.canvas.width, this.canvas.height, () => {
        faded = true;
        if (responseRecieved) {
          self.sceneService.doStartSceneWithParams(this, {}, SceneName.BATTLE_SCENE, this.canvas!.width, this.canvas!.height);
        }
      }, 0, "battleScene");

      BattleStore.attackPlace(placeId).then(() => {
        responseRecieved = true;
        if (faded) {
          self.sceneService.doStartSceneWithParams(this, {}, SceneName.BATTLE_SCENE, this.canvas!.width, this.canvas!.height);
        }
      }).catch(() => {
        if (blackout && blackout instanceof Graphics) {
          self.sceneService.cancelBackground(blackout);
        } else if (blackout){
          self.sceneService.cancelClouds(blackout);
        }
        RoadScene.fadeBlackout = false;
        if (self.scene.isActive()) {
          self.switchScene(SceneName.ROAD_SCENE, {});
        }
      });
    }
  }

  private openCustomPlace(p: CustomPlace, po: PlaceObjects, animSprite: Sprite | undefined, stop: Stop | undefined,
                          lighting: Image | undefined, arrow: Image | undefined, dialogBubble: Image | undefined,
                          open: boolean = true, callback?: (() => unknown) | null): CustomPlaceContainer {
    this.killHerosComments();
    const self = this;
    if (open) {
      self.mouseIsAllowedToInteract = false;
      self.inDialog = true;
      self.isMoving = false;
    }
    SoundUtils.play(self.placeOpenSound);
    let dialog = self.customPlaceService.initDialog(self, self.canvas, p, self.awardSound, self.buttonClickSound,(removePlace: boolean, markCompleted: boolean) => {
      callback && callback();
      if (removePlace) {
        if (po.shadow) {
          po.shadow.destroy();
        }
        if (animSprite) {
          self.animations = self.animations.filter(a => a !== animSprite);
          animSprite.destroy();
        } else {
          if (po.cont) {
            self.containers = self.containers.filter(a => a !== po.cont);
            po.cont.destroy();
          } else {
            self.customPlaceGroup.killAndHide(po.cp);
          }
        }
        if (lighting) {
          self.lightingGroup.killAndHide(lighting);
        }
        if (arrow) {
          self.lightingGroup.killAndHide(arrow);
        }
        if(dialogBubble){
          self.lightingGroup.killAndHide(dialogBubble);
        }
        PlaceStore.REMOVE_PLACE(p.id);
      } else if (markCompleted) {
        // TODO
      }
      if (stop) {
        self.stops = self.stops.filter(s => s !== stop);
      }
      self.mouseIsAllowedToInteract = true;
      self.inDialog = false;
    }, () => {
      BattleStore.attackPlace(p.id).then(() => {
        self.switchScene(SceneName.BATTLE_SCENE, {});
      });
    }, () => {
      this.openShop(true, TabName.BANK);
    }, () => {
      self.actualY = PlayerStore.getCoordinate();
      PlaceStore.CLEAN_UP_PLACES(PlayerStore.getPlayer().coordinate + 5000);
      PlaceService.reset();
      if (p.placeId === 'myself-man2' || p.placeId === 'myself-woman2') {
        self.switchScene(SceneName.LOAD_SCENE, {});
      } else {
        self.switchScene(SceneName.ROAD_SCENE, {});
      }
    }, (heroShopType: HeroShopType) => {
      this.openCastleShop(false, TabName.HERO, heroShopType);
    }, () => {
      self.mouseIsAllowedToInteract = true;
      self.inDialog = false;
    }, ()=>{
      if (dialogBubble) {
          self.lightingGroup.killAndHide(dialogBubble);
        }
    }, ()=>{
      if (dialogBubble) {
        dialogBubble.visible = true;
      }
    }, this.menuService, (id: string) => this.runSpecialCommand(p, id),
        (p:CustomPlace) => this.makeCustomPlace(p));
    if (open) {
      dialog.openAnimated();
    }

    return dialog;
  }

  private openTasks() {
      this.taskService.openTasks(this, this.canvas, () => {
        this.menuService.resourceToSide();
        this.menuContainer!.setDepth(1000);
      }, () => this.listService.showEventPrizesInfo(this, this.canvas, ()=> {}));
      this.menuService.resourceToBottom();
      this.menuContainer!.setDepth(4000);
  }

  private openArena() {
    OnceCaller.doOnce('toArenaScene', () => {
      let self = this;
      let player = PlayerStore.getPlayer();
      if (player.arenaBattlesCount === 0) {
        new ArenaDescPanel(this, this.canvas, player.level >= Settings.ARENA_MIN_LEVEL, () => {
          SoundUtils.play(self.closeSound);
        }, () => {
          SoundUtils.play(self.buttonClickSound);
          this.switchScene(SceneName.ARENA_SCENE, {});
        }).openAnimated();
      } else {
        this.switchScene(SceneName.ARENA_SCENE, {});
      }
    });
  }

  private openChain(chainId: number, chainCont: Container): void {
    let self = this;
    this.chainService.openChain(this, this.canvas, false, () => {
      this.menuService.bringFooterToBottom();
    }, this.paymentNotificationService, (creatureId: string) => {
      this.listService.showManual(this, this.canvas, creatureId, () => {});
    }, TabName.CHAIN, this.listService, this.paymentChangeService, this.iapService,
        chainId, chainCont, () => this.openShop(false, TabName.BANK));
    this.menuService.bringFooterToTop();
  }

  private openSale(saleId: string): void {
    let self = this;

    this.saleService.openSale(this, this.canvas, false, () => {
      this.menuService.bringFooterToBottom();
    }, this.paymentNotificationService, (creatureId: string) => {
      this.listService.showManual(this, this.canvas, creatureId, () => {});
    }, TabName.SALE, this.listService, this.paymentChangeService, this.iapService, saleId);

    this.menuService.bringFooterToTop();
  }

  private openForum() {
    let self = this;
    this.forumService.openForum(this, this.canvas, this.listService, this.menuService,
        this.menuContainer!, undefined, (playerId: number) => {
          self.openProfile(playerId);
        });
  }
  private openHint() {
    TaskStore.setHintSeen();

    let self = this;
    TaskStore.getHint().then(hint => {
      if (hint){
        let ip: HintPanel = new HintPanel(this, this.canvas, hint, () => {
          ip.close();
          SoundUtils.play(self.buttonClickSound);
          PlayerStore.resetRoadNews();
        });
        ip.openAnimated();
      } else {
        new FeedbackPanel(this,  Tr('hint.unavailable'), undefined, false).show();
      }
    });
  }

  private openTopic(topicId: number) {
    let self = this;
    this.forumService.openTopic(this, this.canvas, this.listService, this.menuService,
        this.menuContainer!, undefined, (playerId: number) => {
          self.openProfile(playerId);
        }, topicId);
  }

  private openClan() {
    let self = this;
    OnceCaller.doOnce('toClanScene', () => {
      this.clanService.openClan(this, this.canvas, () => this.switchScene(SceneName.CLAN_SCENE, {}),
          () => self.doSwitchScene(SceneName.CLAN_SCENE, {}),
          () => self.switchSceneInstant(SceneName.ROAD_SCENE, {}),
          self.sceneService,
          self.forumService,
          self.listService,
          () => {
            this.openShop(true, TabName.BANK);
          }, () => {
          this.clanService.openClanRating(this, this.canvas, (title, children) => {
            this.listService.show(this, this.canvas, title, children, () => {
              this.menuService.resourceToSide();
              this.menuContainer!.setDepth(1000);
            });
            this.menuService.resourceToBottom();
            this.menuContainer!.setDepth(4000);
          }, (clanmanInfo: ClanmanInfo) => {
            self.openMemberActionPanel(clanmanInfo, (updatedInfo: ClanmanInfo) => {}, Tr('uchastniki'));
          }, (playerId: number, parentViewId: string) => {
            self.openProfile(playerId);
          });
      });
    });
  }

  public openClanDetailsPanel(ci: ClanShortInfo){
    let self = this;
    this.clanService.showClanDetailsPanel(this, self.canvas, ci, (title, children) =>{
      this.listService.show(this, this.canvas, title, children, () => {
        this.menuService.resourceToSide();
        this.menuContainer!.setDepth(1000);
      });
        this.menuService.resourceToBottom();
        this.menuContainer!.setDepth(4000);
      },
      (clanmanInfo: ClanmanInfo) => {
        self.openMemberActionPanel(clanmanInfo, (updatedInfo: ClanmanInfo) => {}, Tr('uchastniki'));
      }, (playerId: number, parentViewId: string) => {
        self.openProfile(playerId);
      });
  }

  private openShop(noValuteFeedback: boolean, tabName: TabName) {
    this.doOpenShop(this.shopService, noValuteFeedback, tabName);
  }

  private openCastleShop(noValuteFeedback: boolean, tabName: TabName, heroShopType: HeroShopType) {
    switch (heroShopType) {
      case HeroShopType.MONASTERY_SHOP:
        this.doOpenShop(this.monasteryShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.OBLIVION_SHOP:
        this.doOpenShop(this.oblivionShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.ARTIFACT_TOWN:
        this.doOpenShop(this.artifactTownShopService, noValuteFeedback, TabName.ARTIFACT);
        break;
      case HeroShopType.HERO_TOWN:
        this.doOpenShop(this.heroTownShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.TITAN_TOWN:
        this.doOpenShop(this.titanTownShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.ANGEL_TOWN:
        this.doOpenShop(this.angelTownShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.YOTUN_TOWN:
        this.doOpenShop(this.yotunTownShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.SUR_TOWN:
        this.doOpenShop(this.surTownShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.AMETIST_SHOP:
        this.doOpenShop(this.ametistShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.WATER_SHOP:
        this.doOpenShop(this.waterShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.PORTAL_SHOP:
        this.doOpenShop(this.portalShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.SHADOW_SHOP:
        this.doOpenShop(this.shadowShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.RANK_SHOP:
        this.doOpenShop(this.caviarRankShopService, noValuteFeedback, tabName);
        break;
      case HeroShopType.ELEPH_SHOP:
        this.doOpenShop(this.caviarElephShopService, noValuteFeedback, tabName);
        break;
    }
  }

  private doOpenShop(service: ShopService, noValuteFeedback: boolean, tabName: TabName) {
    service.openShop(this, this.canvas, noValuteFeedback, () => {
      this.menuService.bringFooterToBottom();
    }, this.paymentNotificationService, (creatureId: string) => {
      this.listService.showManual(this, this.canvas, creatureId, () => {});
    }, tabName, this.listService, this.paymentChangeService, this.iapService);
    this.menuService.bringFooterToTop();
  }

  private showBonusPointsManual() {
    this.listService.showManual(this, this.canvas, 'bonusPoints', () => {
      this.menuService.resourceToSide();
      this.menuContainer!.setDepth(1000);
    });
    this.menuService.resourceToBottom();
    this.menuContainer!.setDepth(4000);
  }

  private openProfile(playerId: number) {
    let self = this;
    this.profileService.openProfile(this, this.canvas, () => {
          this.menuService.setShowNavPanel(true);
          this.menuService.bringFooterToBottom()
        },
        (moveSpeedButton: PlayerActionButton) => {
          this.playerSpeedService.changeCurrentSpeedMode(moveSpeedButton).then(() => {
            this.setAnimationSpeed();
          });
        }, (moveSpeedButton: PlayerActionButton) => {
          this.playerSpeedService.determineMoveSpeedButtonPrefs(moveSpeedButton);
        }, (sceneName: SceneName, params: any) => this.switchScene(sceneName, params),
        (id: number, support: boolean) => {
          store.dispatch('setMailPartner', {id: id, support: support});
          this.menuService.openMailPage();
        },
        playerId,
        (soundButton: PlayerActionButton) => this.gameSoundService.changeSoundMute(soundButton, () => {
          self.switchSceneWithClouds(SceneName.MUSIC_SCENE, {}, "musicScene")
        }),
        (soundButton: PlayerActionButton) => this.gameSoundService.doSoundMuteAdjustment(soundButton, PlayerStore.getSoundMute()),
        () => {
              this.genderChangeService.open(this, this.canvas, () => {
                this.openShop(true, TabName.BANK);
              });
        }, () => {
          this.paymentChangeService.open(this, this.canvas);
        }, () => {
          this.renamePlayerService.open(this, this.canvas);
        }, () => {
          this.mailOrPhoneService.open(this, this.canvas);
        }, () => {
          this.passwordService.open(this, this.canvas);
        }, ()=>{

          // this.listService.showForcesManual(this, this.canvas, ()=>{this.menuNavPanel.setDepth(1100);})
          this.listService.showForcesManual(this, this.canvas, ()=>{
            this.menuService.resourceToSide();
            this.menuService.bringFooterToBottom();
          })

        }, () => {
          self.switchScene(SceneName.ROAD_SCENE, {});
        },
        (receiver: Profile) => this.giftGemsShopService.openGiftPurchases(this, this.canvas, false, () => {}, this.paymentNotificationService, (creatureId) => {}, TabName.GIFT, this.listService, this.paymentChangeService, this.iapService, receiver),
        () => this.remapYandex(undefined),self.listService, self.menuService);
    this.menuContainer!.setDepth(4000);
    this.menuService.resourceToBottom();
    this.menuService.setShowNavPanel(false);
  }

  private moveTargetReached(): boolean {
    if (this.direction > 0) {
      return this.actualY + this.knightPosition >= this.moveTillY;
    } else {
      return this.actualY + this.knightPosition <= this.moveTillY;
    }
  }

  private lootBoundaryReached(): boolean {
    return this.actualY + this.WORLD_HORIZON > this.lootDisplayedTillY;
  }

  private createResourceGroup(resourceType: ResourceType): Group {
    return this.add.group({
      defaultKey: ResourceUtils.getResourceImageId(resourceType),
      maxSize: 30,
    });
  }

  private getResourceGroup(resourceType: ResourceType): Group {
    switch (resourceType) {
      case ResourceType.GOLD:
        return this.goldGroup;
      case ResourceType.CRYSTAL:
        return this.crystalGroup;
      case ResourceType.ELIXIR:
        return this.elixirGroup;
      case ResourceType.MITHRIL:
        return this.mithrilGroup;
      case ResourceType.SULFUR:
        return this.sulfurGroup;
      case ResourceType.CAVIAR:
        return this.caviarGroup;
      case ResourceType.EVENT_CURRENCY:
        return this.eventCurrencyGroup;
    }
    console.log('Unknown resource type: ' + String(resourceType));
    throw new TypeError();
  }

  private shiftGroup(group: Group, delta: number) {
    let self = this;
    group.children.iterate(function (obj) {
      let image: Image = obj as Image;

      image!.y += self.getObjectsDelta(delta);
      if (image.y > self.canvas.height + 250 && PlayerStore.getPlayer().controlType !== ControlType.BW_FW) {
        image.resetPipeline(true);
        image.removeAllListeners();
        group.killAndHide(image);
      }
      return true;
    });
  }

  private spawnClickFlashSprite(x: number, y: number): void {

    this.clickFlash = SpriteUtils.addSpriteN(this, x, y, Keys.IMG_CLICK_FLASH);

    this.tweens.add({
      targets: this.clickFlash,
      alpha: 0,
      delay: 75,
      duration: this.CLICK_FLASH_LIFESPAN
    });

    this.time.addEvent({delay: this.CLICK_FLASH_LIFESPAN, callback: this.destroyClickFlashSprite, callbackScope: this})
  }

  private destroyClickFlashSprite(): void {
    this.clickFlash.destroy();
  }

  private spawnCrosshairSprite(y: number) {

    let middleOfTheMap = this.canvas.width / 2;

    this.crosshair = SpriteUtils.addSpriteN(this, middleOfTheMap, y, this.crosshairKey());

  }

  private crosshairKey(): string {
    if (this.worldType === WorldType.CLAN_RAID) {
      return Keys.IMG_CROSS_SNOW;
    }
    return Keys.IMG_CROSSHAIR;
  }

  private destroyCrosshairSprite(): void {
    if (this.crosshair) {
      this.crosshair.destroy();
      this.crosshair = undefined;
    }
  }

  private clickIsNotBehindThePlayer(): boolean {
    return this.moveTillY > this.actualY;
  }

  private switchScene(sceneName: SceneName, params: any) {
    this.stopEverithingInScene();
    this.sceneService.startSceneWithParams(this, params, sceneName, this.canvas!.width, this.canvas!.height);
  }
  private switchSceneWithClouds(sceneName: SceneName, params: any, key:string) {
    this.stopEverithingInScene();
    this.sceneService.startSceneWithParamsAndClouds(this, this.canvas, params, sceneName, this.canvas!.width, this.canvas!.height, key);
  }

  private doSwitchScene(sceneName: SceneName, params: any) {
    this.stopEverithingInScene();
    this.sceneService.doStartSceneWithParams(this, params, sceneName, this.canvas!.width, this.canvas!.height);
  }

  private switchSceneInstant(sceneName: SceneName, params: any) {
    this.stopEverithingInScene();
    this.sceneService.startSceneInstant(this, params, sceneName);
  }

  private stopEverithingInScene() {
    this.syncCoordinate();
    if (this.mainThemeSound) {
      SoundUtils.stop(this.mainThemeSound);
    }
    if (this.horseWalkSound) {
      SoundUtils.stop(this.horseWalkSound);
    }
    this.experienceService.stopListenPlayer();
  }

  private syncCoordinate() {
    const self = this;
    this.placeService.shiftPlayer(this.actualY, PlayerStore.getMinCoordinate(), PlayerStore.getPlayer().controlType, () => {
      self.setupTiles();

      let player = PlayerStore.getPlayer();
      if (self.mainThemeSound && self.mainThemeSound.key === player.specialMusicKey && player.specialMusicTillCoord
            && player.coordinate > player.specialMusicTillCoord) {
        self.setupMusic(player);
      }
    });
  }

  private toggleWeatherEffect(effectIsGoing: boolean, effectKey: string, textureKey?: string|undefined): void {
    let tiles: Tile[] = PlaceStore.getTiles();

    for (let t of tiles) {
      let tileRoad: TileRoad|undefined = this.findTileRoadById(t.id);
      let tileSprite: TileSprite |undefined = tileRoad?.tileSprite;

      if (tileSprite && (tileSprite.pipeline.name !== effectKey || !effectIsGoing)) {
        if (textureKey && t.textureKey !== textureKey) continue;

        (effectIsGoing && this.isWEBGLRenderer) ? tileSprite.setPipeline(effectKey) : tileSprite.resetPipeline(true);
      }
    }
  }

  private rainInAnim(): void {
    let self = this;
    let hc = new HeroComment();
    hc.text = Tr('cat.rain');
    let catId = CreatureUtils.findCatOrRandom().id;
    hc.heroId = catId;
    this.showHerosComment(hc, 2000, 5000);
    this.time.delayedCall(7000, () => {
      if (self.scene.isActive()) {
        hc = new HeroComment();
        hc.text = Tr('hum.rain');
        hc.heroId = CreatureUtils.findHumanOrRandom(catId).id;
        this.showHerosComment(hc, 2000, 8000);
      }
    });
    let bgFade = SpriteUtils
      .addSprite(this, 0, 0, Keys.IMG_BLACK_BACKGROUND)
      .setOrigin(0)
      .setAlpha(0)
      .setDepth(-999);

    this.tweens.add({
      targets: bgFade,
      duration: 1000,
      alpha: 0.4,
      onComplete: () => {
        this.toggleWeatherEffect(true, "RainPipeline");
        bgFade.setAlpha(0);
      }
    });
  }

  private rainOutAnim(): void {
    this.toggleWeatherEffect(false, "RainPipeline");

    let bgFade = SpriteUtils
    .addSprite(this, 0, 0, Keys.IMG_BLACK_BACKGROUND)
    .setOrigin(0)
    .setAlpha(0)
    .setDepth(-999);


    this.tweens.add({
      targets: bgFade,
      duration: 1000,
      alpha: { from: 0.4, to: 0},
    });
  }

  private setupTiles() {
    if (this.turnInProgress) {
      return;
    }
    let tiles: Tile[] = PlaceStore.getTiles();

    this.rainCanGoing = tiles.every(t => !NO_RAIN_AREAS_KEYS.includes(t.textureKey));
    if (this.effectStatus === EffectStatus.Going && !this.rainCanGoing) {
      this.effectStatus = EffectStatus.Stopped;
      this.minuteOfTheRainActivation = this.game.loop.now + 1 * 60 * 1000;
    }

    for (let t of tiles) {
      let tileRoad = this.findTileRoadById(t.id);

      if (tileRoad) {
        tileRoad.yTo = t.yto;
      } else {
        tileRoad = new TileRoad();
        tileRoad.id = t.id;
        tileRoad.yFrom = t.yfrom;
        tileRoad.yTo = t.yto;

        let y = 0;
        let tileY = 0;

        // textureHeight - это длина объекта текстуры. Она равна либо высоте канваса, либо меньше, если текстура короче.
        let textureHeight = (t.yto ? Math.min(this.canvas!.height, (t.yto - t.yfrom) * CU.S) : this.canvas!.height) + 10;

        if (t.yfrom >= this.actualY) { // кейс, когда начало тайла перед конем
          y = this.actualY * CU.S + this.canvas.height - t.yfrom * CU.S;
          tileY = (textureHeight / CU.S - t.textureLength);
        } else if (t.yto && t.yto * CU.S < this.actualY * CU.S + this.canvas.height) { // кейс, когда конец тайла в пределах видимости
          y = this.actualY * CU.S + this.canvas.height + textureHeight - t.yto * CU.S - 1;
          tileY = 0;
        } else {
          y = this.canvas.height;
          tileY = (this.actualY + textureHeight / CU.S - t.yfrom);
        }
        // Bridge is a png picture (with transparent boundaries). Tile Sprite can't be transparent, so creating usual sprite here
        if (t.textureKey === 'bridge' || t.textureKey === 'bridge_2') {
          tileRoad.sprite = SpriteUtils.addSprite(this, 0, y / CU.S, t.textureKey).setOrigin(0, 0.72).setDepth(-999);
        } else if (t.textureKey === 'gate_1') {
          tileRoad.sprite = SpriteUtils.addSprite(this, 0, y / CU.S, t.textureKey).setOrigin(0, 0.72).setDepth(-999);

          let tileRoad2 = new TileRoad();
          tileRoad2.id = t.id;
          tileRoad2.yFrom = t.yfrom;
          tileRoad2.yTo = t.yto;
          tileRoad2.sprite = SpriteUtils.addSprite(this, 0, y / CU.S, 'gate_2').setOrigin(0, 0.72).setDepth(2);
          this.tileRoads.push(tileRoad2);
        } else if (t.textureKey === 'arch_1') {
          tileRoad.sprite = SpriteUtils.addSprite(this, 0, y / CU.S, t.textureKey).setOrigin(0, 0.72).setDepth(-999);

          let tileRoad2 = new TileRoad();
          tileRoad2.id = t.id;
          tileRoad2.yFrom = t.yfrom;
          tileRoad2.yTo = t.yto;
          tileRoad2.sprite = SpriteUtils.addSprite(this, 0, y / CU.S, 'arch_2').setOrigin(0, 0.72).setDepth(2);
          this.tileRoads.push(tileRoad2);
        } else {
          tileRoad.tileSprite = SpriteUtils.addTileSprite(this, 0, y, this.canvas!.width, textureHeight, t.textureKey).setOrigin(0, 1).setDepth(-1000);
          tileRoad.tileSprite.tilePositionY = -tileY;
        }

        this.tileRoads.push(tileRoad);

        let self = this;
        (tileRoad.tileSprite ? tileRoad.tileSprite : tileRoad.sprite)!.setInteractive().on('pointerdown', function(pointer: any) {

          let windowSizeChanged = false;
          OnceCaller.doOnce("checkCanvasResize", () => {
            windowSizeChanged = CU.checkCanvasSize(self, () => {
              self.time.delayedCall(100, () => {
                CU.WINDOW_RESIZED = false;
                RoadScene.fadeBlackout = false;
                self.switchSceneInstant(SceneName.ROAD_SCENE, {});
              });
            });
          });
          if (windowSizeChanged) {
            return;
          } else if (self.mouseIsAllowedToInteract && self.isMovingAllowed) {

            self.isMoving = true;

            self.moveTillY = self.actualY + self.canvas.height / CU.S - pointer.y / CU.S;
            if (PlayerStore.getPlayer().controlType === ControlType.BW_FW) {
              self.direction = self.canvas.height / CU.S - pointer.y / CU.S > self.knightPosition ? 1 : -1;
              self.moveTillY = Math.max(PlayerStore.getMinCoordinate() + self.BOTTOM_MIN_DISTANCE, self.moveTillY);
              self.moveTillY = Math.min(PlayerStore.getMaxCoordinate() - self.TOP_MIN_DISTANCE, self.moveTillY);
            }

            self.spawnClickFlashSprite(pointer.position.x, pointer.position.y);

            self.destroyCrosshairSprite();

            if (self.clickIsNotBehindThePlayer()) {
              self.spawnCrosshairSprite(pointer.position.y);
              self.syncCoordinate();
            }
          } else if (!self.mouseIsAllowedToInteract || !self.isMovingAllowed) {
            //console.log('self.mouseIsAllowedToInteract = ' + self.mouseIsAllowedToInteract);
            //console.log('self.isMovingAllowed = ' + self.isMovingAllowed);
          }
        });
      }
      this.setupKmCounter(tileRoad, t.textureKey);
      this.updateRemainKmText();
    }
  }

  private setupKmCounter(t: TileRoad, textureKey: string) {
    let self = this;
    if (t && t.yTo && this.actualY <= t.yTo) {
      switch (textureKey) {
        case 'water_straight':
        case 'water_straight_2':
          self.worldStartCoordinate = t.yFrom;
          self.worldEndCoordinate = t.yTo - 500;
          self.waterWorldMode = true;
          GameState.showSulfur = true;
          GameState.showEventValue = false;
          break;
        case 'dream_straight':
        case 'heaven_straight':
        case 'fire_straight':
        case 'water_elem_straight':
        case 'earth_straight':
        case 'air_straight':
        case 'p9_secret_portal':
          self.worldStartCoordinate = t.yFrom;
          self.worldEndCoordinate = t.yTo;
          break;
        case 'ny_straight':
          self.worldStartCoordinate = t.yFrom;
          self.worldEndCoordinate = t.yTo;
          GameState.showCaviar = true;
          break;
        case 'asg_straight':
          GameState.showSulfur = true;
          GameState.showEventValue = false;
          // No break!
        case 'atlant_straight':
        case 'atlantis_twilight':
          self.worldStartCoordinate = t.yFrom;
          self.worldEndCoordinate = t.yTo;
      }
    }
  }

  private findTileRoadById(id: number) {
    for (let t of this.tileRoads) {
      if (t.id === id) {
        return t;
      }
    }
    return undefined;
  }

  private static haveSpecialMusic(): boolean {
    let player = PlayerStore.getPlayer();
    return player && !!player.specialMusicKey && !!player.specialMusicTillCoord && player.coordinate < player.specialMusicTillCoord;
  }

  private setupMusic(player: Player) {
    if (this.mainThemeSound) {
      SoundUtils.stop(this.mainThemeSound);
    }

    MusicUtils.ROAD_MUSIC_KEYS = MusicUtils.getRoadMusicKeysToPlay(player);

    let musicKey = MusicUtils.ROAD_MUSIC_KEYS[0];

    if (RoadScene.haveSpecialMusic()) {
      musicKey = player.specialMusicKey!;
    } else if (Date.now() - PlayerStore.getGameStart() > 30000) {
      musicKey = RandomUtils.getRandom(MusicUtils.ROAD_MUSIC_KEYS);
    }

    this.mainThemeSound = SoundUtils.addSound(this, musicKey, {volume: Settings.MUSIC_VOLUME});

    SoundUtils.setLooped(this.mainThemeSound);
    SoundUtils.play(this.mainThemeSound);
  }

  private killEducations(placeId: number): void {
    this.educationService.destroyAllEducationTriggers(placeId);
    this.educationService.killEducationObjects(placeId, this.setMouseEnable.bind(self));
  }

  private setAnimationSpeed() {
    Knight.setWalkFrameRateRatio(this.playerSpeedService.getSpeedMultiplier());
  };

  private getObjectsDelta(timeDelta: number) {
    return this.getDistanceDelta(timeDelta) * CU.S;
  }

  private getDistanceDelta(timeDelta: number) {
    if (this.actualY > this.lootDisplayedTillY) {
      return this.direction;
    }
    let currentSpeed = this.playerSpeedService.getPlayerSpeedByMultiplier();
    return currentSpeed * (timeDelta / this.FRAME_RATE_DELAY) * this.direction;
  }

  private openExchangePanel(): void {
    let self = this;
    SoundUtils.play(self.placeOpenSound);
    let ip: IntroPanel = new IntroPanel(self, self.canvas, Tr('rinok'), '',
        'atlas_places_1', 'exchange_inn',
        Tr('dobro.pozhalovat.na.rinok'),
        Tr('zaplatit.za.nih.mozhno.zolotom'), () => {
          ip.close();
          OnceCaller.doOnce("openExchange", () => {
            ExchangeStore.getExchangeTerms().then((exchangeDto: ExchangeTerms) => {
              let panel = new ExchangePanel(self, self.canvas, PlayerStore.getPlayer(), exchangeDto, (exchangeDtoFrom: ExchangeAmount) => {
                OnceCaller.doOnce('convertCurrencies', () => {
                  ExchangeStore.convertCurrencies(exchangeDtoFrom);
                });
              });
              panel.open();
            });
          });
        });
    ip.openAnimated();
  }

  private openMemberActionPanel(ci: ClanmanInfo, closeCallback: (updatedInfo: ClanmanInfo) => unknown, parentViewId: string) {
    let self = this;
    new MemberActionPanel(this, this.canvas, ci, () => {
      self.listService.close(parentViewId);
      self.profileService.openProfile(this, this.canvas, () => {},
          () => {}, () => {}, () => {},
          (id: number, support: boolean) => {
            store.dispatch('setMailPartner', {id: id, support: support});
            this.menuService.openMailPage();
          },
          ci.playerId,
          () => {}, () => {}, () => {}, () => {},
          () => {},  () => {}, () => {},() => {}, () => {},
          (receiver: Profile) => self.giftGemsShopService.openGiftPurchases(self, self.canvas, false, () => {}, self.paymentNotificationService, (creatureId) => {}, TabName.GIFT, self.listService, self.paymentChangeService, self.iapService, receiver),
          () => {}, self.listService, self.menuService);
    }, () => {
      store.dispatch('setMailPartner', {id: ci.playerId, support: false});
      self.menuService.openMailPage();
    }, (ca: ClanControlAction) => {
      ClanStore.participantAction(ci.playerId, ca).then((updatedInfo: ClanmanInfo) => {
        closeCallback(updatedInfo);
        new FeedbackPanel(this, ClanUtils.getActionFeedback(ca), undefined, true).show();
      });
    }).openAnimated();
  }

  private updateRemainKmText() {
    if (this.worldStartCoordinate && this.worldEndCoordinate) {
      if (this.worldStartCoordinate <= this.actualY && this.actualY < this.worldEndCoordinate) {
        if (!this.headerBack || !this.headerText || (this.headerBack && !this.headerBack.active) || (this.headerText && !this.headerText.active)) {
          this.headerBack = SpriteUtils.addSprite(this, 210, 0, Keys.KM_HEAD, undefined, 0.8, 1).setOrigin(0.5, 0);
          this.headerBack.setDepth(MenuService.DEFAULT_DEPTH);
          this.headerText = TextUtils.addTextAdvanced(this, '', 210, 8, '#fefefe', 9, 'normal',
              200, 'center', 2, Fonts.ARIAL_MT);
          this.headerText.setDepth(MenuService.DEFAULT_DEPTH + 1);
        }

        if (this.headerText) {
          if (this.headerText.active) {
            let km = (this.worldEndCoordinate - this.actualY) / 10;
            this.headerText.setText(String(km.toFixed(0)) + Tr('m'));
          } else {
            console.log('ATTENTION!');
          }
        }

      } else {
        if (this.headerBack && this.headerText) {
          this.headerText.setVisible(false)
          this.headerBack.setVisible(false);
          this.headerText.destroy();
          this.headerBack.destroy();
          this.worldStartCoordinate = undefined;
          this.worldEndCoordinate = undefined;
          this.waterWorldMode = false;
          GameState.showSulfur = false;
          GameState.showCaviar = false;
          GameState.showEventValue = true;
        }
      }
    }
  }

  private createCustomPlaceSprite(p: CustomPlace, x: number, y: number): PlaceObjects {
    let self = this;

    let shadow;

    let cp: Image | Sprite | undefined = undefined;
    switch (p.animType) {
      case AnimType.EMPTY:
        if (p.shadowOffset > 0) {
          shadow = SpriteUtils.groupCreate(self, self.shadowsGroup, x, y + p.shadowOffset, Keys.PLACE_SHADOW);
        }
        // make an empty image
        cp = SpriteUtils.groupCreate(self, self.customPlaceGroup, x, y, Keys.EMPTY);
        let sizes = p.imageId.split('x');
        SpriteUtils.setDispSize(cp!, Number.parseInt(sizes[0]), Number.parseInt(sizes[1]));
        return new PlaceObjects(cp!, undefined, shadow);
      case AnimType.CAT_DROWN_MALE:
      case AnimType.CAT_DROWN_FEMALE:
        let yPos = p.animType === AnimType.CAT_DROWN_MALE ? 10 : 7;
        shadow = SpriteUtils.addSprite(self, 0, yPos, p.animType === AnimType.CAT_DROWN_MALE ? 'cat_male' : 'cat_female');
        let shad: Sprite = shadow;
        cp = p.atlasId ? SpriteUtils.addSprite(self, 0, 0, p.atlasId, p.imageId) : SpriteUtils.addSprite(self, 0, 0, p.imageId);
        let contHole = new Container(self, x * CU.S, y * CU.S);
        let lastTime = Date.now();
        self.tweens.add({
          targets: shad,
          radius: 3,
          yoyo: true,
          repeat: -1,
          onUpdate: function ()
          {
            let delta = Date.now() - lastTime;
            lastTime = Date.now();
            Phaser.Actions.RotateAroundDistance([shad!], { x: 0, y: yPos }, delta / 700, 4);
          }
        });
        self.containers.push(contHole);
        contHole.add(cp!);
        self.add.existing(contHole);
        if (shadow) {
          contHole.add(shadow);
        }
        return new PlaceObjects(cp, contHole, shadow);
      case AnimType.NONE:
        if (p.shadowOffset > 0) {
          shadow = SpriteUtils.groupCreate(self, self.shadowsGroup, x, y + p.shadowOffset, Keys.PLACE_SHADOW);
        }
        cp = !p.animationId ? (p.atlasId ? SpriteUtils.groupCreate(self, self.customPlaceGroup, x, y, p.atlasId, p.imageId) : SpriteUtils.groupCreate(self, self.customPlaceGroup, x, y, p.imageId) ) : undefined;
        return new PlaceObjects(cp!, undefined, shadow);
      case AnimType.TEETER:
        if (p.shadowOffset > 0) {
          shadow = SpriteUtils.addSprite(self, 0, p.shadowOffset, Keys.PLACE_SHADOW);
        }
        let cont1 = new Container(self, x * CU.S, y * CU.S);
        cp = p.atlasId ? SpriteUtils.addSprite(self, 0, 0, p.atlasId, p.imageId) : SpriteUtils.addSprite(self, 0, 0, p.imageId);
        self.tweens.chain({
          targets: cp,
          loop: -1,
          tweens: [
            {
              delay: Math.random() * 5000,
              duration: 300,
              angle: 5,
            },{
              duration: 300,
              angle: 0,
            }]
        });
        self.containers.push(cont1);
        cont1.add(cp!);
        if (shadow) {
          cont1.add(shadow);
        }
        self.add.existing(cont1);
        return new PlaceObjects(cp, cont1, shadow);
      case AnimType.FLYING:
        if (p.shadowOffset > 0) {
          shadow = SpriteUtils.addSprite(self, 0, p.shadowOffset, Keys.PLACE_SHADOW);
        }
        cp = p.atlasId ? SpriteUtils.addSprite(self, 0, 0, p.atlasId, p.imageId) : SpriteUtils.addSprite(self, 0, 0, p.imageId);
        let cont2 = new Container(self, x * CU.S, y * CU.S);
        self.tweens.add({
          targets: cp,
          radius: 3,
          duration: 1500,
          yoyo: true,
          repeat: -1,
          onUpdate: function ()
          {
            Phaser.Actions.RotateAroundDistance([cp!], { x: 0, y: 0 }, 0.02, 3);
          }
        });
        self.containers.push(cont2);
        cont2.add(cp!);
        self.add.existing(cont2);
        if (shadow) {
          cont2.add(shadow);
        }
        return new PlaceObjects(cp, cont2, shadow);
      case AnimType.FLY_VERTICAL:
        if (p.shadowOffset > 0) {
          shadow = SpriteUtils.addSprite(self, 0, p.shadowOffset, Keys.PLACE_SHADOW);
          SpriteUtils.scale(shadow, p.shadowScale * CU.S);
        }
        cp = p.atlasId ? SpriteUtils.addSprite(self, 0, 0, p.atlasId, p.imageId) : SpriteUtils.addSprite(self, 0, 0, p.imageId);
        let cont3 = new Container(self, x * CU.S, y * CU.S - 20 * CU.S);
        let dur = 2300 + Math.random() * 400;
        self.tweens.chain({
          targets: cp,
          loop: -1,
          tweens: [
            {
              duration: dur,
              props: {
                y: { value: -4, ease: 'Sine.InOut' }
              }
            },{
              duration: dur,
              props: {
                y: { value: 4, ease: 'Sine.InOut' }
              }
            }
          ]
        });
        if (shadow) {
          self.tweens.chain({
            targets: shadow,
            loop: -1,
            tweens: [
              {
                duration: dur,
                props: {
                  scale: {value: 1.1 * p.shadowScale * CU.S, ease: 'Sine.InOut'},
                  y: {value: p.shadowOffset + 2, ease: 'Sine.InOut'}
                }
              }, {
                duration: dur,
                props: {
                  scale: {value: CU.S * p.shadowScale, ease: 'Sine.InOut'},
                  y: {value: p.shadowOffset, ease: 'Sine.InOut'}
                }
              }
            ]
          });
          cont3.add(shadow);
        }
        self.containers.push(cont3);
        cont3.add(cp!);
        self.add.existing(cont3);
        return new PlaceObjects(cp, cont3, shadow);
    }
    throw new Error();
  }

  private createPlacePhrase(p: CustomPlace, phrases: Talk[], x: number, y: number): void {
    if (phrases && phrases.length > 0) {
      const animDuration = phrases[phrases.length - 1].delayMs + 4000;
      phrases.forEach((phras: Talk) => {
        const showPhrase = (delay: number): void => {
          this.time.delayedCall(delay, () => {
            if (!p.used) {
              this.killCurrentPlacePhrase();

              const POS_Y = this.educationService
                                .worldYToCanvasY(y, this.actualY, this.game.canvas.height) - (60 * CU.S);
              const CONTAINER = this.add.container();

              const PHRASE_PANEL = new PhrasePanel(this, x * CU.S, POS_Y, phras.text.length > 15 ? 11 : 13);
              PHRASE_PANEL.show(phras.text, 2500, 750);

              CONTAINER.add(PHRASE_PANEL);
              this.containers.push(CONTAINER);

              this.currentPlacePhrase = PHRASE_PANEL;

              showPhrase(animDuration);
            }
          });
        }

        showPhrase(phras.delayMs);
      })
    }
  }

  private killCurrentPlacePhrase = () => {
   this.currentPlacePhrase?.destroy();
   this.currentPlacePhrase = null;
  };

  public showArrow(point: Point, arrowMode: ArrowMode, flipX: boolean = false, flipY: boolean = false, small: boolean = false, arrowDelay: number = 300): ArrowAnimData {
    const ARROW_HEIGHT = 112;

    let shiftX = (!small ? (flipX ? -30 : 30) : 0);
    let shiftY = (flipY ? -20 : 20);

    let ARROW_X = point.x + shiftX;
    let ARROW_Y = point.y - shiftY - ((ARROW_HEIGHT - 16) * CU.S);
    const CONT = this.add.container().setDepth(2000);

    const FLYING_ARROW: Image = SpriteUtils.addSprite(this, ARROW_X, ARROW_Y, Keys.UI_ARROW)
      .setOrigin(0, 0).setAlpha(0).setPosition(ARROW_X, ARROW_Y);

    if (!small) {
      if (flipX) ARROW_X -= (ARROW_HEIGHT - 13) * CU.S;
      if (flipY) ARROW_Y += (ARROW_HEIGHT - 30) * CU.S;
      FLYING_ARROW.flipX = flipX;
      FLYING_ARROW.flipY = flipY;
    } else {
      FLYING_ARROW.setScale(0.4);
      ARROW_X -= 17 * CU.S;
      ARROW_Y += 42 * CU.S;
      FLYING_ARROW.angle = -55;
    }
    FLYING_ARROW.setPosition(ARROW_X, ARROW_Y);

    CONT.add(FLYING_ARROW);
    this.addContainerToTheRoad(CONT);

    let APPEARANCE_ANIM;
    let YOYO_ANIM;

    switch (arrowMode) {
      case ArrowMode.PERSISTENT:
        APPEARANCE_ANIM = this.tweens.chain({
          targets: FLYING_ARROW,
          persist: true,
          tweens: [
            {
              delay: arrowDelay,
              duration: 1000,
              alpha: {from: 0, to: 1}
            }
          ]
        });
        break;
      case ArrowMode.PERIODIC:
        APPEARANCE_ANIM = this.tweens.chain({
          targets: FLYING_ARROW,
          persist: true,
          loop: -1,
          tweens: [
            {
              delay: arrowDelay,
              duration: 1000,
              alpha: {from: 0, to: 1}
            },
            {
              delay: arrowDelay + 2600,
              duration: 1000,
              alpha: {from: 1, to: 0}
            },
            {
              alpha: {from: 0, to: 0},
              duration: 2600,
            }
          ]
        });
        break;
      case ArrowMode.ONE_TIME:
        APPEARANCE_ANIM = this.tweens.chain({
          targets: FLYING_ARROW,
          persist: true,
          tweens: [
            {
              delay: arrowDelay,
              duration: 1000,
              alpha: {from: 0, to: 1}
            },
            {
              delay: arrowDelay + 2600,
              duration: 1000,
              alpha: {from: 1, to: 0}
            },
          ]
        });
        break;
    }

    YOYO_ANIM = this.tweens.add({
      targets: FLYING_ARROW,
      delay: 0,
      duration: arrowMode === ArrowMode.PERSISTENT ? 2000 : 1300,
      x: FLYING_ARROW.x - shiftX,
      y: FLYING_ARROW.y + shiftY,
      yoyo: true,
      loop: -1
    });

    return {gameObjects: [FLYING_ARROW, APPEARANCE_ANIM, YOYO_ANIM]}
  }

  private showHandAnimations(point: Point): HandAnimData {
      const SELF = this;
      const POS_X = point.x + 46;
      const POS_Y = point.y + 30;
      const CONT = SELF.add.container().setDepth(2000);

      const HAND = SpriteUtils.addSprite(SELF, POS_X, POS_Y, Keys.IMG_LESSON_HAND)
                              .setOrigin(0.5).setDepth(2001).setPosition(POS_X, POS_Y);
      const SHADOW = SpriteUtils.addSprite(SELF, POS_X, POS_Y, Keys.IMG_LESSON_HAND_SHADOW)
                              .setOrigin(0.5).setDepth(2000).setPosition(POS_X, POS_Y);

      CONT.add([SHADOW, HAND]);
      SELF.addContainerToTheRoad(CONT);

      const DURATION = 1200;
      const OFFSET_X = 50;
      const OFFSET_Y = 30;
      const EASE = 'Quad.easeOut';
      let purticleAnim;

      const HAND_ANIM = SELF.tweens.add({
            targets: HAND,
            x: HAND.x + OFFSET_X,
            y: HAND.y - OFFSET_Y,
            duration: DURATION,
            ease: EASE,
            yoyo: true,
            loop: -1,

            onLoop() {
                  purticleAnim = ParticleUtils.showParticleWave(SELF, point.x + 10, point.y - 10);
            }
      });

      const SHADOW_ANIM = SELF.tweens.add({
            targets: SHADOW,
            x: SHADOW.x - OFFSET_X,
            y: SHADOW.y + OFFSET_Y,
            duration: DURATION,
            ease: EASE,
            yoyo: true,
            loop: -1,
      });

      return {
            hand: HAND,
            shadow: SHADOW,
            handAnim: HAND_ANIM,
            shadowAnim: SHADOW_ANIM
      }
  }

  private showHerosComment(heroComment: HeroComment, delay: number, duration: number): void {
    console.log('Showing ' + heroComment.text);
    const HERO_COMMENT = this.herosComments.get(heroComment.heroId);
    if (HERO_COMMENT && HERO_COMMENT.text === heroComment.text) return;

    this.killHerosComments();

    const CREATURE_INDEX = this.getCreaturIndexById(heroComment.heroId);
    const TEXT = heroComment.text;
    const ICON_POINT: Point = this.menuNavPanel.getPosByIndex(CREATURE_INDEX);
    const FRAME_X = ICON_POINT.x - (225 * CU.S);
    const FRAME_Y = ICON_POINT.y - (102 * CU.S);
    const FRAME_SCALE_X: number = 1 * CU.S;
    const FRAME_SCALE_Y: number = 1 * CU.S;
    const TEXT_X = FRAME_X + (22 * CU.S);
    const TEXT_Y = FRAME_Y - (13 * CU.S);

    const CONTAINER = this.add.container().setDepth(2002).setAlpha(0);

    const COMMENT_FRAME: Image = SpriteUtils.addSprite(this, 0, 0, Keys.HEROES_COMMENT_3)
                .setOrigin(0, 0.5).setScale(FRAME_SCALE_X, FRAME_SCALE_Y).setPosition(FRAME_X, FRAME_Y);

    const COMMENT_TEXT: Text = TextUtils.addTextAdvanced(this, TEXT, TEXT_X, TEXT_Y, '#ffffff', TEXT.length < 60 ? 13 : 12,
                'normal', (COMMENT_FRAME.displayWidth - (40 * CU.S)) / CU.S, 'left', 0, Fonts.ARIAL_MT)
                .setOrigin(0, 0.5).setPosition(TEXT_X, TEXT_Y);
    COMMENT_TEXT.setStroke('#000000', 3);

    if ((this.getCombativeCreatureCount() - 1) === CREATURE_INDEX) {
      COMMENT_FRAME.setTexture(Keys.HEROES_COMMENT_2);
    } else {
      const POSITION_X = FRAME_X + COMMENT_FRAME.displayWidth / 3.8 - 4;
      COMMENT_FRAME.setX(POSITION_X);
      COMMENT_TEXT.setX(POSITION_X + (20 * CU.S));
    }

    CONTAINER.add([COMMENT_FRAME,COMMENT_TEXT]);

    const COMMENT_ANIM = this.tweens.chain({
          targets: CONTAINER,
          tweens: [
                {
                      delay: delay,
                      y: { value:{from: 30, to: 0}, ease: 'power3', duration: 1000},
                      alpha: {value:{ from: 0, to: 1 }, ease: 'power3', duration: 1000},
                },
                {
                      alpha: { from: 1, to: 0 },
                      ease: 'power3',
                      duration: 1000,
                      delay: duration,
                      onComplete: () => {
                        this.killHeroCommentData(heroComment.heroId);
                      }
                }
          ],
    });

    const HERO_COMMENT_DATA: HeroCommentData = {
      text: TEXT,
      commentText: COMMENT_TEXT,
      commentFrame: COMMENT_FRAME,
      commentAnim: COMMENT_ANIM
    };

    this.herosComments.set(heroComment.heroId, HERO_COMMENT_DATA);
  }

  private killHerosComments(): void {
    for (let hc of this.herosComments.keys()) {
      this.killHeroCommentData(hc);
    }
  }

  private killHeroCommentData(heroId: number): void {
    const DATA = this.herosComments.get(heroId);
    DATA!.commentAnim.destroy();
    DATA!.commentText.destroy();
    DATA!.commentFrame.destroy();

    this.herosComments.delete(heroId);
  }

  private getCreaturIndexById(creatureId: number): number {
      let reversedNonTemporalCreaturesList = CreatureUtils.findNonTemporalCreatures(CreatureUtils.sortCreaturesAscending(PlayerStore.getPlayer().creatures));
      const orderedCreaturesList = CreatureUtils.getOrderedCreaturesList(reversedNonTemporalCreaturesList);

      for (let i = 0, j = 0; i < orderedCreaturesList.length; ++i) {
            if (i >= MenuCreaturesNavPanel.MAX_CREATURES_NO_ARROWS) return 0;
            if (!orderedCreaturesList[i]) {
                  ++j;
                  continue;
            } else if (orderedCreaturesList[i].id === creatureId) return i - j;
      }

      return 0;
  }

  private getCombativeCreatureCount = () => PlayerStore.getPlayer().creatures.map(c => c.combative).length;

  private getEducationPanelWithButton(teacherKey: string, title: string, text: string, answer: string, postScriptId: string | undefined, place: Place | undefined) {
    let self = this;
    self.isMovingAllowed = false;
    return new EduWithButton(this, teacherKey, title, text, answer, this.buttonClickSound, () => {
      self.isMovingAllowed = true;
      if (postScriptId) {
        this.runSpecialCommand(place, postScriptId);
      }
    });
  }

  private getEducationPanel(educationText: string, speakerFrameKey: string): EducationPanel|undefined {
    if (this.currentEducationPanel && educationText === this.currentEducationPanel.text) return;

    this.currentEducationPanel && this.currentEducationPanel.educationPanel.destroy();
    this.currentEducationPanel = null;

    const EDU_PANEL = new EducationPanel(this, 0, PlayerStore.getPlayer() && PlayerStore.getPlayer().level <= 1 ? undefined : () => {
      EDU_PANEL.destroy();
    });
    this.add.existing(EDU_PANEL);

    EDU_PANEL.init(speakerFrameKey, educationText, () => {});

    const EDUCATION_PANEL_DATA: EducationPanelData = {
      text: educationText,
      educationPanel: EDU_PANEL
    }

    this.currentEducationPanel = EDUCATION_PANEL_DATA;
    return EDU_PANEL;
  }

  private runSpecialCommand(place: Place | undefined, id: string) {
    let self = this;
    switch (id) {
      case 'rabbitLetter':
        let rs = new RabbitScroll(self, self.canvas);
        rs.setCloseListener(() => {
          PlayerStore.setMarker('gotRabLetter');
        });
        SoundUtils.play(self.awardSound);
        rs.openAnimated();
        break;
      case 'roadHandAndRabbitTask':
        this.getLessonService().showRoadHand(self);
        new NewTaskFeedback(self, Tr('ntr')).show();
        break;
      case 'roadHand':
        this.getLessonService().showRoadHand(self);
        break;
      case 'goblinHelp':
        if (!this.CONTAINER && this.actualY + CU.CANVAS_HEIGHT * CU.ETALON_CANVAS_WIDTH / CU.CANVAS_WIDTH < 3800) {
          this.createCryAnim(new Point(390 * CU.S,20 * CU.S), Tr('help'), 5, 8000);
          let hc = new HeroComment();
          hc.text = Tr('h.h');
          hc.heroId = CreatureUtils.findCat().id;
          this.showHerosComment(hc, 3000, 300000);
          let coord = self.actualY;
          this.time.delayedCall(5000, () => {
            if (!self.isMoving && self.actualY === coord) {
              self.getLessonService().showRoadHand(self);
            }
          });
          this.CONTAINER.play();
        }
        break;
      case 'goblinHelpBind':
        if (!this.containers.includes(this.CONTAINER)) {
          this.containers.push(this.CONTAINER);
        }
        break;
      case 'absX':
        self.mouseIsAllowedToInteract = false;
        self.isMoving = false;
        self.isMovingAllowed = false;
        self.allBlocked = true;
        let timerId3 = setInterval(() => {
          self.absCustomPlacesX();
          clearInterval(timerId3);
        }, 1000);
        let timerId1 = setInterval(() => {
          self.allBlocked = false;
          clearInterval(timerId1);
        }, 6600);
        self.educationService.busyTill = new Date().getTime() + 6600;
        break;
      case 'absX2':
        self.isMoving = false;
        PlaceStore.getPlacesAll().forEach(p => {
          if (p.placeType === PlaceType.CUSTOM) {
            let cp: CustomPlace = p as CustomPlace;
            cp.posX = Math.abs(cp.posX);
            if (cp.placeId === 'goblin1') {
              PlaceStore.REMOVE_PLACE(cp.id);
            }
          }
        });
        break;
      case 'absX3':
        self.isMoving = false;
        PlaceStore.getPlacesAll().forEach(p => {
          if (p.placeType === PlaceType.CUSTOM) {
            let cp: CustomPlace = p as CustomPlace;
            cp.posX = Math.abs(cp.posX);
            if (cp.placeId === 'wr-2') {
              PlaceStore.REMOVE_PLACE(cp.id);
            }
          }
        });
        break;
      case 'absXU':
        self.isMoving = false;
        PlaceStore.getPlacesAll().forEach(p => {
          if (p.placeType === PlaceType.CUSTOM) {
            let cp: CustomPlace = p as CustomPlace;
            cp.posX = Math.abs(cp.posX);
            let initialCp = place as CustomPlace;
            if (cp.placeId === initialCp.placeId) {
              PlaceStore.REMOVE_PLACE(cp.id);
            }
          }
        });
        break;
      case 'absXAfter':
        self.mouseIsAllowedToInteract = false;
        self.isMoving = false;
        self.isMovingAllowed = false;
        break;
    }
  }

  private absCustomPlacesX(): void {
    this.customPlaceGroup.children.iterate((obj) => {
      let image: Image = obj as Image;
      if (image && image!.x < 0) {
        image!.x = Math.abs(image!.x);

      }
      return true;
    });

    this.creaturesGroup.children.iterate((obj) => {
      let image: Image = obj as Image;
      if (image && image!.x < 0) {
        image!.x = Math.abs(image!.x) + this.CREATURE_OFFSET_X * 2;
      }
      return true;
    });

    for (let p of PlaceStore.getPlacesAll()) {
      if (p.posX < 0) {
        p.posX = Math.abs(p.posX);
      }
    }
  }

  public createHeroJoiningAnim(heroTexture: string, text: string, creatureIndex: number, heroFrame?: string): void {
    const LAST_POINT: Point = this.menuNavPanel.getPosByIndex(0);
    LAST_POINT.x -= 61 * CU.S;

    const BG = SpriteUtils.addSprite(this, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setAlpha(0).setOrigin(0).setDepth(2000);
    SpriteUtils.setDispSize(BG, CU.CANVAS_WIDTH, CU.CANVAS_HEIGHT);

    const yPos = CU.CANVAS_HEIGHT / 2.15;
    const LIGHT: Image = SpriteUtils.addSprite(this, 0, 0, Keys.OFFER_LIGHT_BACK)
      .setOrigin(0.5).setScale(4 * CU.S).setPosition(CU.CANVAS_WIDTH / 2, yPos).setAlpha(0).setDepth(2000);

    const HERO: Image = SpriteUtils.addSprite(this, 0, 0, heroTexture)
      .setOrigin(0.5).setScale(1 * CU.S).setPosition(CU.CANVAS_WIDTH / 2, yPos).setAlpha(0).setDepth(2001);

    const TEXT: Text = TextUtils.addTextAdvanced(this, text, CU.CANVAS_WIDTH / 2 / CU.S, (yPos + 230 * CU.S) / CU.S,
      '#ffffff', 28 / CU.S, 'normal', 450 / CU.S, 'center', 2, Fonts.ARIAL_MT).setAlpha(0).setDepth(2002).setOrigin(0.5);
    TEXT.setStroke("#000000", 1);

    const LIGHT_ANIM = this.tweens.chain({
      targets: LIGHT,
      persist: true,
      tweens: [
        {
          alpha: { value: { from: 0, to: 1 }, duration: 300 },
          angle: { value: { from: 0, to: 9 }, duration: 600 },
        },
        {
          angle: { value: { from: 9, to: 67 }, duration: 4500 },
        },
        {
          angle: { value: { from: 67, to: 82 }, duration: 1000 },
          alpha: { value: { from: 1, to: 0 }, duration: 600 },
        },
      ]
    }).pause();

    const TEXT_ANIM = this.tweens.chain({
      targets: TEXT,
      persist: true,
      delay: 3000,
      tweens: [
        {
          targets: TEXT,
          alpha: { value: { from: 0, to: 1 }, duration: 600 },
          scale: { value: { from: 0, to:  1 * CU.S }, duration: 600 },
        },
        {
          delay: 1000,
          targets: TEXT,
          alpha: { value: { from: 1, to: 0 }, duration: 600 },
        },
      ]
    }).pause();

    const BG_ANIM = this.tweens.chain({
      targets: BG,
      tweens: [
        {
          targets: BG,
          alpha: { value: { from: 0, to: 0.1 },  duration: 200 },
          onComplete: () => {
            this.awardSound?.play();
            LIGHT_ANIM.resume();
            TEXT_ANIM.resume();
          }
        },
        {
          targets: BG,
          alpha: { value: { from: 0.1, to: 0.3 },  duration: 600 },
        },
      ]
    }).play();

    this.tweens.chain({
      targets:[BG, LIGHT, HERO],
      persist: true,
      tweens: [
        {
          targets: HERO,
          alpha: { value: { from: 0, to: 1 }, duration: 1200 },
          scale: { value: { from: 0.5 * CU.S, to: 1 * CU.S }, duration: 1200 },
        },
        {
          targets: [HERO, TEXT],
          scale: { value: { from: 1 * CU.S, to: 1.1 * CU.S }, duration: 2000, yoyo: true }
        },
        {
          targets: HERO,
          x: LAST_POINT.x,
          y: LAST_POINT.y,
          scale: 0.25 * CU.S,
          duration: 800,
        },
        {
          targets: BG,
          alpha: { value: { from: 0.3, to: 0 },  duration: 500 },
        },
        {
          targets: HERO,
          alpha: 0,
          duration: 200,
        },
      ]
    });
  }

  private createCryAnim(
      point: Point,
      text: string,
      arcsCountPerStep?: number,
      delayBetweenSteps: number = 6000,
      minDistanceBetweenTexts: number = 18
    ) {
    const CONTAINER =  this.add.container(point.x, point.y);
    const FULL_ANIM_DURATION: number = 2000;
    let texts: Text[] = [];

    this.cryAnimIsPlaying = true;
    let currentStepCount: number;
    if (arcsCountPerStep) currentStepCount = arcsCountPerStep;

    let func = () => {
      this.time.delayedCall(1000, () => {
        SoundUtils.play(this.helpWom);
      });
      this.time.delayedCall(3000, () => {
        SoundUtils.play(this.helpMan);
        this.time.delayedCall(8200, () => {
          func();
        });
      });
    };
    func();

    const createArcAnim = () => {
      const ARC: Image = SpriteUtils.addSprite(this, 0, 0, Keys.IMG_ARC)
        .setOrigin(0.5)
        .setScale(0.5 * CU.S)
        .setPosition(0, 0)
        .setAlpha(0)
        .setDepth(2001);

      CONTAINER.add(ARC);
      const TEXT_APPEARANCE_TIME: number = Math.random() * FULL_ANIM_DURATION;
      const RAND_OFFSET_X: number = this.getRandomNumberFromRange(-25, 25);
      const RAND_OFFSET_Y: number = this.getRandomNumberFromRange(-15, 15);
      const TEXT_CORRECTION_FACTOR: number = TEXT_APPEARANCE_TIME / 0.66 / 6000;
      const SCALE_CORRECTION: number = 0.3 * TEXT_CORRECTION_FACTOR;
      const ALPHA_CORRECTION: number = 0.2 * TEXT_CORRECTION_FACTOR;
      const OFFSET_X: number = - (35 * CU.S);
      const OFFSET_Y: number = 80 * CU.S;

      this.time.delayedCall(TEXT_APPEARANCE_TIME, () => {
        const TEXT: Text = TextUtils
        .addTextAdvanced(this, text, 0, 0, '#ffffff', 14, 'normal', 180, 'center', 2, Fonts.ARIAL_MT)
        .setAlpha(0)
        .setDepth(2002)
        .setOrigin(0.5)
        .setStroke("#000000", 1)
        .setScale(0.7 + SCALE_CORRECTION)
        .setPosition(- (8 * CU.S) + (OFFSET_X * TEXT_CORRECTION_FACTOR * 0.66) + (RAND_OFFSET_X * CU.S),
        (20 * CU.S) + (OFFSET_Y * TEXT_CORRECTION_FACTOR * 0.66) + (RAND_OFFSET_Y * CU.S));
        CONTAINER.add(TEXT);

        const TEXT_FOLLOWING_ANIM = this.add.tween({
          targets: TEXT,
          x: (- (8 * CU.S)) + OFFSET_X - 40 * CU.S + (RAND_OFFSET_X * CU.S),
          y: ((20 * CU.S)) + OFFSET_Y + 60 * CU.S + (RAND_OFFSET_Y * CU.S),
          duration: 6200 * (1 - TEXT_CORRECTION_FACTOR * 0.66)
        });

        if (!texts.some(text => Math.abs(text.y - TEXT.y) < minDistanceBetweenTexts)) {
          texts.push(TEXT);

          this.tweens.chain({
            targets: TEXT,
            tweens: [
              {
                alpha: { from: 0, to: 0.8 + ALPHA_CORRECTION },
                duration: 600
              },
              {
                delay: 1000,
                alpha: { from: 1, to: 0 },
                duration: 1200,
                onComplete: () => {
                  texts.shift();
                  TEXT_FOLLOWING_ANIM.destroy();
                  TEXT.destroy();
                }
              }
            ]
          });
        }
      });

      this.tweens.chain({
        targets: ARC,
        persist: true,
        tweens: [
          {
            alpha: { value: { from: 0, to: 1 }, duration: 600 },
            scale: { from: 0.2 * CU.S, to: 0.7 * CU.S },
            x: - 50 * CU.S,
            y: 100 * CU.S,
            duration: 2000
          },
          {
            alpha: { from: 1, to: 0 },
            x: - 60 * CU.S,
            y: 120 * CU.S,
            duration: 600,
            onComplete: () => {
              ARC.destroy();
            }
          }
        ]
      });

      if (!arcsCountPerStep) {
        this.time.delayedCall(600, () => {
          this.cryAnimIsPlaying && createArcAnim();
        });
      } else if (currentStepCount > 0) {
        --currentStepCount;
        this.time.delayedCall(600, () => {
          this.cryAnimIsPlaying && createArcAnim();
        });
      } else if (currentStepCount === 0) {
        currentStepCount = arcsCountPerStep;
        this.time.delayedCall(delayBetweenSteps, () => {
          this.cryAnimIsPlaying && createArcAnim();
        });
      }
    }

    (CONTAINER as any).play = () => {
      this.cryAnimIsPlaying = true;
      createArcAnim();
    };

    (CONTAINER as any).stop = () => {
      this.cryAnimIsPlaying = false;
    }

    (CONTAINER as any).killAnim = () => {
      CONTAINER.list.forEach(obj => obj.destroy());
      CONTAINER.destroy();
    }
    this.CONTAINER = CONTAINER;
  }

  private getLessonService() {
    return this.lessonService;
  }

  private getRandomNumberFromRange(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  private createBird(): void {
    let self = this;
    const birdContainer = this.add.container().setDepth(2);
    const isReverse = Math.round(Math.random() * 10) > 5;

    let startPointX: number = -50;
    let endPointX: number = CU.CANVAS_WIDTH + 50;
    let startPointY: number = Math.round(Math.random() * CU.CANVAS_HEIGHT);
    let endPointY: number = startPointY; // Math.round(Math.random() * CU.CANVAS_HEIGHT);

    if (isReverse) [startPointX, endPointX] = [endPointX, startPointX];

    const birdKey = Math.round(Math.random()) === 1 ? Keys.ANIM_BIRD_FLIGHT : Keys.ANIM_BLUE_BIRD_FLIGHT;

    AnimationUtils.createAnimation(this, birdKey);

    const sprite = SpriteUtils.addSprite(this, 300, startPointY, birdKey)
      .setScale(CU.S)
      .setFlipX(isReverse);

    sprite.play(birdKey);

    birdContainer.add(sprite);
    this.containers.push(birdContainer);

    this.tweens.add({
      targets: sprite,
      x: { from: startPointX, to: endPointX },
      y: { from: startPointY, to: endPointY },
      duration: 15000,
      onComplete() {
        if (self.scene.isActive()) {
          self.time.delayedCall(60000 + Math.random() * 60000, () => {
            if (self.scene.isActive()) {
              self.createBird();
            }
          });
        }
      }
    });
  }

  public reload(): void {
    this.switchSceneInstant(SceneName.ROAD_SCENE, {});
  }

  private remapYandex(accCont: Container | undefined): void {
    let self = this;

    let yaStorageIds = YaStorage.getAllIds();
    let player = PlayerStore.getPlayer();
    if (!!yaStorageIds && !!player) {
      SecurityStore.searchYandex(yaStorageIds).then((list: PlayerShortInfo[]) => {
        if (list && list.length > 0) {

          let pp = new YaAccPanel(this, this.canvas, list, Tr('ac.no'), (uniqueId: string) => {
            OnceCaller.doOnce('remapAcc', () => {
              SecurityStore.remapYandex(Http.YA_UNIQUE_ID!, uniqueId).then(() => {
                pp.close();
                window.location.reload();
              });
            });
          }, () => {
            let ip = new InfoPanel(this, this.canvas, Tr('ok'), Tr('ac.cm1'), Tr('ac.cm2'), () => {
              if (!!accCont) {
                accCont.destroy();
              }
              YaStorage.setChooseRejected();
            });
            ip.openAnimated();
          });
          pp.openAnimated();

        } else {
          if (!!accCont) {
            accCont.destroy();
          }
          YaStorage.setChooseRejected();
        }
      });
    }
  }
}

enum EffectStatus {
  Going = 1,
  Sleeping = 2,
  Stopped = 3
}

class PlaceObjects {
  cp: Image | Sprite;
  cont: Container | undefined;
  shadow: Sprite | undefined;

  constructor(cp: Image | Sprite, cont: Container | undefined, shadow: Sprite | undefined) {
    this.cp = cp;
    this.cont = cont;
    this.shadow = shadow;
  }
}

export type HeroCommentData = {
  text: string,
  commentText: Text
  commentFrame: Image,
  commentAnim: any
}

export const NO_RAIN_AREAS_KEYS = ['road_fire'];

export type EducationPanelData = {
  text: string,
  educationPanel: EducationPanel
}
